/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateDeckInput = {
  deck_name?: string | null,
  deck_id: string,
  enabled_page_grains?: Array< string | null > | null,
  enabled_datasets?: Array< DatasetSource | null > | null,
};

export enum DatasetSource {
  GALAXY = "GALAXY",
  HCTR = "HCTR",
}


export type Deck = {
  __typename: "Deck",
  pk: string,
  sk: string,
  deckGSI_pk?: string | null,
  deckGSI_sk?: string | null,
  deck_name?: string | null,
  created_date?: string | null,
  last_updated_date?: string | null,
  created_by?: string | null,
  last_updated_by?: string | null,
  current_user?: string | null,
  locked_by?: string | null,
  locked_at?: string | null,
  lock_expiry?: string | null,
  publish_status?: PublishStatus | null,
  publish_user?: string | null,
  publish_deck_cycle?: string | null,
  has_active_system_run?: boolean | null,
  last_publish_date?: string | null,
  publish_timestamp?: string | null,
  deck_cycle?: string | null,
  enabled_page_grains?: Array< string | null > | null,
  enabled_datasets?: Array< DatasetSource | null > | null,
};

export enum PublishStatus {
  PUBLISH_STARTED = "PUBLISH_STARTED",
  PUBLISH_IN_PROGRESS = "PUBLISH_IN_PROGRESS",
  KPI_UPLOAD_COMPLETED = "KPI_UPLOAD_COMPLETED",
  KPI_UPLOAD_FAILED = "KPI_UPLOAD_FAILED",
  KPI_CALCULATION_COMPLETED = "KPI_CALCULATION_COMPLETED",
  KPI_CALCULATION_FAILED = "KPI_CALCULATION_FAILED",
  DECK_UPDATE_COMPLETED = "DECK_UPDATE_COMPLETED",
  DECK_UPDATE_FAILED = "DECK_UPDATE_FAILED",
}


export type CreateTOCEntryInput = {
  deck_id: string,
  toc_id: string,
  page_id?: string | null,
  page_no?: string | null,
  toc_page_name?: string | null,
  page_name?: string | null,
  is_visible?: boolean | null,
  is_active: boolean,
  group_name?: string | null,
  serial_no?: number | null,
};

export type TOCEntry = {
  __typename: "TOCEntry",
  pk: string,
  sk: string,
  toc_id: string,
  page_id?: string | null,
  page_no?: string | null,
  toc_page_name?: string | null,
  page_name?: string | null,
  is_visible?: boolean | null,
  is_active?: boolean | null,
  group_name?: string | null,
  serial_no?: number | null,
  created_date?: string | null,
  last_updated_date?: string | null,
  schedule_type?: ScheduleType | null,
};

export enum ScheduleType {
  APPROVED = "APPROVED",
  MODIFIED = "MODIFIED",
}


export type CreateScenarioManagementEntryInput = {
  deck_id: string,
  scenario_id: string,
  deck_cycle?: string | null,
  month?: string | null,
  page_name?: string | null,
  page_no?: string | null,
  sno?: string | null,
  is_external_page?: boolean | null,
  page_grain?: string | null,
  schedule_type?: ScheduleType | null,
  is_supplemental?: boolean | null,
  is_blankpage?: boolean | null,
  toc_sno?: string | null,
  toc_page_no?: string | null,
};

export type ScenarioManagementEntry = {
  __typename: "ScenarioManagementEntry",
  pk: string,
  sk: string,
  scenario_id: string,
  deck_cycle?: string | null,
  month?: string | null,
  page_name?: string | null,
  page_no?: string | null,
  sno?: string | null,
  is_external_page?: boolean | null,
  page_grain?: string | null,
  schedule_type: ScheduleType,
  last_updated_date?: string | null,
  is_supplemental?: boolean | null,
  is_blankpage?: boolean | null,
  toc_sno?: string | null,
  toc_page_no?: string | null,
};

export type CreatePageInput = {
  page_id: string,
  page_name?: string | null,
  deck_id?: string | null,
  page_grain?: string | null,
  page_no?: number | null,
  previous_page_id?: string | null,
  next_page_id?: string | null,
  page_drivers?: Array< KPIDriversInput | null > | null,
  page_type?: string | null,
  denominator_label?: DenominatorLabelValues | null,
  scale?: PageScaleValues | null,
  layout_family?: string | null,
  report_header?: string | null,
};

export type KPIDriversInput = {
  galaxy?: GalaxyKPIDriversInput | null,
  hctr?: HctrKPIDriversInput | null,
};

export type GalaxyKPIDriversInput = {
  account_hierarchy?: string | null,
  account?: string | null,
  location_hierarchy?: string | null,
  location?: string | null,
  project_hierarchy?: string | null,
  project?: string | null,
  company_hierarchy?: string | null,
  company?: string | null,
  product_hierarchy?: string | null,
  product?: string | null,
  revgp_hierarchy?: string | null,
  revgp?: string | null,
  datasource_hierarchy?: string | null,
  datasource?: string | null,
  channel_hierarchy?: string | null,
  channel?: string | null,
  costcenter_hierarchy?: string | null,
  costcenter?: string | null,
  costtype?: string | null,
  costpool?: string | null,
  fieldtype?: string | null,
};

export type HctrKPIDriversInput = {
  measure_hierarchy?: string | null,
  measure?: string | null,
  transferDirection_hierarchy?: string | null,
  transferDirection?: string | null,
  workflow_hierarchy?: string | null,
  workflow?: string | null,
  company_hierarchy?: string | null,
  company?: string | null,
  costcenter_hierarchy?: string | null,
  costcenter?: string | null,
  location_hierarchy?: string | null,
  location?: string | null,
  costtype?: string | null,
  fieldtype?: string | null,
};

export enum DenominatorLabelValues {
  GROSS_MARGIN = "GROSS_MARGIN",
  REVENUE = "REVENUE",
  OPERATING_MARGIN = "OPERATING_MARGIN",
}


export enum PageScaleValues {
  MILLIONS = "MILLIONS",
  ONES = "ONES",
}


export type Page = {
  __typename: "Page",
  pk: string,
  sk: string,
  pageGSI_pk?: string | null,
  pageGSI_sk?: string | null,
  page_name?: string | null,
  deck_id?: string | null,
  page_grain?: string | null,
  page_no?: number | null,
  page_drivers?:  Array<KPIDrivers | null > | null,
  previous_page_id?: string | null,
  next_page_id?: string | null,
  page_type?: string | null,
  denominator_label?: DenominatorLabelValues | null,
  scale?: PageScaleValues | null,
  locked_by?: string | null,
  locked_at?: string | null,
  lock_expiry?: string | null,
  layout_family?: string | null,
  report_header?: string | null,
};

export type KPIDrivers = {
  __typename: "KPIDrivers",
  datasetSource?: DatasetSource | null,
  company_hierarchy?: string | null,
  company?: string | null,
  costcenter_hierarchy?: string | null,
  costcenter?: string | null,
  costtype?: string | null,
  fieldtype?: string | null,
  location_hierarchy?: string | null,
  location?: string | null,
};

export type GalaxyKPIDrivers = {
  __typename: "GalaxyKPIDrivers",
  datasetSource?: DatasetSource | null,
  account_hierarchy?: string | null,
  account?: string | null,
  location_hierarchy?: string | null,
  location?: string | null,
  project_hierarchy?: string | null,
  project?: string | null,
  company_hierarchy?: string | null,
  company?: string | null,
  product_hierarchy?: string | null,
  product?: string | null,
  revgp_hierarchy?: string | null,
  revgp?: string | null,
  datasource_hierarchy?: string | null,
  datasource?: string | null,
  channel_hierarchy?: string | null,
  channel?: string | null,
  costcenter_hierarchy?: string | null,
  costcenter?: string | null,
  costtype?: string | null,
  costpool?: string | null,
  fieldtype?: string | null,
};

export type HctrKPIDrivers = {
  __typename: "HctrKPIDrivers",
  datasetSource?: DatasetSource | null,
  measure_hierarchy?: string | null,
  measure?: string | null,
  transferDirection_hierarchy?: string | null,
  transferDirection?: string | null,
  workflow_hierarchy?: string | null,
  workflow?: string | null,
  company_hierarchy?: string | null,
  company?: string | null,
  costcenter_hierarchy?: string | null,
  costcenter?: string | null,
  location_hierarchy?: string | null,
  location?: string | null,
  costtype?: string | null,
  fieldtype?: string | null,
};

export type CreateDecklineInput = {
  calc_members?: CalcExpressionInput | null,
  page_id: string,
  deckline_id: string,
  page_name?: string | null,
  kpi_id?: string | null,
  kpi_name?: string | null,
  kpi_formula?: string | null,
  serial_no?: string | null,
  is_code_or_description?: CodeOrDescription | null,
  is_format_bold?: boolean | null,
  is_format_italics?: boolean | null,
  is_format_underline?: boolean | null,
  format_text_color?: string | null,
  format_cell_color?: string | null,
  format_cell_default?: CellFormat | null,
  format_cell_overrides?: Array< DecklineCellFormatInput > | null,
  blankline_type?: BlanklineType | null,
  is_format_borderline?: boolean | null,
  footnotes?: Array< number | null > | null,
  subtotal_formula?: string | null,
  is_calculated_kpi?: CalculatedKPIValues | null,
  subtotal_parent?: string | null,
  deckline_drivers?: GalaxyKPIDriversInput | null,
  is_exception?: boolean | null,
  page_section?: string | null,
  column_template?: string | null,
  adjcalcflag?: boolean | null,
  exceptioncalculatedkpiflag?: boolean | null,
  bordertopflag?: boolean | null,
  borderrightflag?: boolean | null,
  borderbottomflag?: boolean | null,
  borderleftflag?: boolean | null,
  borderweightflag?: BorderWeight | null,
  textunderlineflag?: boolean | null,
  denominator_kpi_id_for_pct?: string | null,
  denominator_kpi_id_drivers?: GalaxyKPIDriversInput | null,
  denominator_is_calculated_kpi?: CalculatedKPIValues | null,
  denominator_kpi_formula?: string | null,
  root_kpi_id?: string | null,
  kpi_variant_id?: string | null,
  display_name?: string | null,
  denominator_kpi_variant_id?: string | null,
  measure?: string | null,
  kpi_name_indent_level?: number | null,
  fxinclflag?: string | null,
  calcdivisionflag?: string | null,
  bps_override_flag?: string | null,
  comments?: Array< CommentInput | null > | null,
};

export type CalcExpressionInput = {
  dimension: string,
  tokens: Array< CalcTokenInput >,
  pins?: Array< CalcPinInput > | null,
  dataset_source?: DatasetSource | null,
};

export type CalcTokenInput = {
  kind: CalcTokenKind,
  value: string,
  hierarchy?: string | null,
};

export enum CalcTokenKind {
  NODE = "NODE",
  OPERATOR = "OPERATOR",
}


export type CalcPinInput = {
  dimension: string,
  node: string,
  hierarchy?: string | null,
};

export enum CodeOrDescription {
  CODE = "CODE",
  DESCRIPTION = "DESCRIPTION",
  BOTH = "BOTH",
}


export enum CellFormat {
  NONE = "NONE",
  NUMBER = "NUMBER",
  PERCENT = "PERCENT",
  PERCENT_1 = "PERCENT_1",
  PERCENT_2 = "PERCENT_2",
  BPS = "BPS",
}


export type DecklineCellFormatInput = {
  colKey: string,
  format: CellFormat,
};

export enum BlanklineType {
  BLANKLINE = "BLANKLINE",
  BLANKLINE_ADJUSTMENT = "BLANKLINE_ADJUSTMENT",
  BLANKLINE_CALCULATED_ADJUSTMENT = "BLANKLINE_CALCULATED_ADJUSTMENT",
}


export enum CalculatedKPIValues {
  I = "I",
  Y = "Y",
  N = "N",
  NA = "NA",
}


export enum BorderWeight {
  N = "N",
  THIN = "THIN",
  THICK = "THICK",
}


export type CommentInput = {
  commentId: string,
  user: string,
  commentDesc: string,
  timestamp: string,
};

export type Deckline = {
  __typename: "Deckline",
  calc_members?: CalcExpression | null,
  pk: string,
  sk: string,
  page_name?: string | null,
  kpi_id?: string | null,
  kpi_id_by_override?:  Array<DecklineCellKpiId | null > | null,
  kpi_name?: string | null,
  kpi_formula?: string | null,
  serial_no?: string | null,
  is_code_or_description?: CodeOrDescription | null,
  is_format_bold?: boolean | null,
  is_format_italics?: boolean | null,
  is_format_underline?: boolean | null,
  format_text_color?: string | null,
  format_cell_color?: string | null,
  format_cell_default?: CellFormat | null,
  format_cell_overrides?:  Array<DecklineCellFormat | null > | null,
  blankline_type?: BlanklineType | null,
  is_format_borderline?: boolean | null,
  footnotes?: Array< number | null > | null,
  subtotal_formula?: string | null,
  subtotal_parent?: string | null,
  is_calculated_kpi?: CalculatedKPIValues | null,
  kpi_type?: KPIType | null,
  deckline_kind?: DecklineKind | null,
  deckline_drivers?: KPIDrivers | null,
  is_exception?: boolean | null,
  page_section?: string | null,
  column_template?: string | null,
  adjcalcflag?: boolean | null,
  exceptioncalculatedkpiflag?: boolean | null,
  bordertopflag?: boolean | null,
  borderrightflag?: boolean | null,
  borderbottomflag?: boolean | null,
  borderleftflag?: boolean | null,
  borderweightflag?: BorderWeight | null,
  textunderlineflag?: boolean | null,
  denominator_kpi_id_for_pct?: string | null,
  denominator_kpi_id_drivers?: GalaxyKPIDrivers | null,
  denominator_is_calculated_kpi?: CalculatedKPIValues | null,
  denominator_kpi_formula?: string | null,
  root_kpi_id?: string | null,
  kpi_variant_id?: string | null,
  display_name?: string | null,
  denominator_kpi_variant_id?: string | null,
  measure?: string | null,
  kpi_name_indent_level?: number | null,
  fxinclflag?: string | null,
  calcdivisionflag?: string | null,
  bps_override_flag?: string | null,
  comments?:  Array<Comment | null > | null,
};

export type CalcExpression = {
  __typename: "CalcExpression",
  dimension?: string | null,
  tokens?:  Array<CalcToken | null > | null,
  pins?:  Array<CalcPin | null > | null,
};

export type CalcToken = {
  __typename: "CalcToken",
  kind?: CalcTokenKind | null,
  value?: string | null,
};

export type CalcPin = {
  __typename: "CalcPin",
  dimension?: string | null,
  node?: string | null,
};

export type DecklineCellKpiId = {
  __typename: "DecklineCellKpiId",
  override_set?: GalaxyKPIDrivers | null,
  kpi_id: string,
};

export type DecklineCellFormat = {
  __typename: "DecklineCellFormat",
  colKey: string,
  format: CellFormat,
};

export enum KPIType {
  BASE = "BASE",
  CALCULATED = "CALCULATED",
  EXTERNAL = "EXTERNAL",
}


export enum DecklineKind {
  BASE = "BASE",
  SUBTOTAL = "SUBTOTAL",
  BLANKLINE = "BLANKLINE",
  CALCULATED = "CALCULATED",
  ADJUSTMENT = "ADJUSTMENT",
  CALCULATED_ADJUSTMENT = "CALCULATED_ADJUSTMENT",
}


export type Comment = {
  __typename: "Comment",
  commentId: string,
  user: string,
  commentDesc: string,
  timestamp: string,
};

export type CreateDeckColumnInput = {
  page_id: string,
  deck_id?: string | null,
  deckcolumn_id: string,
  column_template?: string | null,
  page_section?: string | null,
  column_no?: number | null,
  column_title?: string | null,
  column_name?: string | null,
  no_of_columns?: number | null,
  column_description?: string | null,
  scenario_display_name?: string | null,
  scenario_period?: string | null,
  block_id?: number | null,
  footnotes?: Array< number | null > | null,
  comparison_scenario?: string | null,
  comparison_scenario_period?: string | null,
  fx_scenario?: string | null,
  fx_scenario_period?: string | null,
  denominator_scenario?: string | null,
  denominator_scenario_period?: string | null,
  block_header?: string | null,
  non_material_flag?: string | null,
  denominator_kpi_exception_flag?: string | null,
  column_mapping_group?: string | null,
  report_header?: string | null,
  time_grain?: string | null,
  deck_cycle?: string | null,
};

export type DeckColumn = {
  __typename: "DeckColumn",
  pk: string,
  sk: string,
  deckColumnGSI_pk?: string | null,
  deckColumnGSI_sk?: string | null,
  deck_id?: string | null,
  column_template?: string | null,
  page_section?: string | null,
  column_no?: number | null,
  column_title?: string | null,
  column_name?: string | null,
  no_of_columns?: number | null,
  column_description?: string | null,
  scenario_display_name?: string | null,
  scenario_period?: string | null,
  block_id?: number | null,
  comparison_scenario?: string | null,
  comparison_scenario_period?: string | null,
  fx_scenario?: string | null,
  fx_scenario_period?: string | null,
  denominator_scenario?: string | null,
  denominator_scenario_period?: string | null,
  block_header?: string | null,
  non_material_flag?: string | null,
  denominator_kpi_exception_flag?: string | null,
  last_updated_date?: string | null,
  column_mapping_group?: string | null,
  report_header?: string | null,
  time_grain?: string | null,
  deck_cycle?: string | null,
};

export type CreateKPIInput = {
  kpi_id: string,
  deck_id: string,
  is_calculated_kpi?: CalculatedKPIValues | null,
  kpi_formula?: string | null,
  kpi_map?: GalaxyKPIDriversInput | null,
};

export type KPI = {
  __typename: "KPI",
  pk: string,
  sk: string,
  is_calculated_kpi?: CalculatedKPIValues | null,
  kpi_type?: KPIType | null,
  kpi_formula?: string | null,
  kpi_map?: KPIDrivers | null,
  last_updated_date?: string | null,
};

export type CreateFootnoteInput = {
  footnote_id: string,
  page_id: string,
  footnote_no?: string | null,
  footnote_description?: string | null,
};

export type Footnote = {
  __typename: "Footnote",
  pk: string,
  sk: string,
  footnote_no?: string | null,
  footnote_description?: string | null,
};

export type SaveDeckInput = {
  deck_id: string,
  deck_name: string,
  save_timestamp: string,
  change_set: ChangesInput,
};

export type ChangesInput = {
  toc?: TOCOperationsInput | null,
  deckline?: DecklineOperationsInput | null,
  deckcolumn?: DeckColumnOperationsInput | null,
  footnote?: FootnoteOperationsInput | null,
  kpi?: KPIOperationsInput | null,
  page?: PageOperationsInput | null,
  scenario?: ScenarioManagementOperationsInput | null,
  audit?: AuditHistoryOperationsInput | null,
};

export type TOCOperationsInput = {
  create?: Array< TOCItemsInput | null > | null,
  update?: Array< TOCItemsInput | null > | null,
  delete?: Array< TOCDeleteItemsInput | null > | null,
};

export type TOCItemsInput = {
  toc_id: string,
  page_id?: string | null,
  page_no?: string | null,
  toc_page_name?: string | null,
  page_name?: string | null,
  is_visible?: boolean | null,
  is_active: boolean,
  group_name?: string | null,
  serial_no?: number | null,
  schedule_type?: ScheduleType | null,
  enabled_grains?: Array< string | null > | null,
};

export type TOCDeleteItemsInput = {
  toc_id: string,
};

export type DecklineOperationsInput = {
  create?: Array< DecklineItemsInput | null > | null,
  update?: Array< DecklineItemsInput | null > | null,
  delete?: Array< DecklineDeleteItemsInput | null > | null,
};

export type DecklineItemsInput = {
  page_id: string,
  deckline_id: string,
  page_name?: string | null,
  kpi_id?: string | null,
  kpi_name?: string | null,
  kpi_formula?: string | null,
  serial_no?: string | null,
  is_code_or_description?: CodeOrDescription | null,
  is_format_bold?: boolean | null,
  is_format_italics?: boolean | null,
  is_format_underline?: boolean | null,
  format_text_color?: string | null,
  format_cell_color?: string | null,
  format_cell_default?: CellFormat | null,
  format_cell_overrides?: Array< DecklineCellFormatInput > | null,
  blankline_type?: BlanklineType | null,
  is_format_borderline?: boolean | null,
  footnotes?: Array< number | null > | null,
  subtotal_formula?: string | null,
  subtotal_parent?: string | null,
  is_calculated_kpi?: CalculatedKPIValues | null,
  deckline_kind?: DecklineKind | null,
  deckline_drivers?: GalaxyKPIDriversInput | null,
  is_exception?: boolean | null,
  page_section?: string | null,
  column_template?: string | null,
  adjcalcflag?: boolean | null,
  exceptioncalculatedkpiflag?: boolean | null,
  bordertopflag?: boolean | null,
  borderrightflag?: boolean | null,
  borderbottomflag?: boolean | null,
  borderleftflag?: boolean | null,
  borderweightflag?: BorderWeight | null,
  textunderlineflag?: boolean | null,
  denominator_kpi_id_for_pct?: string | null,
  denominator_kpi_id_drivers?: GalaxyKPIDriversInput | null,
  denominator_is_calculated_kpi?: CalculatedKPIValues | null,
  denominator_kpi_formula?: string | null,
  root_kpi_id?: string | null,
  kpi_variant_id?: string | null,
  display_name?: string | null,
  denominator_kpi_variant_id?: string | null,
  measure?: string | null,
  kpi_name_indent_level?: number | null,
  fxinclflag?: string | null,
  calcdivisionflag?: string | null,
  bps_override_flag?: string | null,
  comments?: Array< CommentInput | null > | null,
};

export type DecklineDeleteItemsInput = {
  page_id: string,
  deckline_id: string,
};

export type DeckColumnOperationsInput = {
  create?: Array< DeckColumnItemsInput | null > | null,
  update?: Array< DeckColumnItemsInput | null > | null,
  delete?: Array< DeckColumnDeleteItemsInput | null > | null,
};

export type DeckColumnItemsInput = {
  page_id: string,
  deckcolumn_id: string,
  column_template?: string | null,
  page_section?: string | null,
  column_no?: number | null,
  column_title?: string | null,
  column_name?: string | null,
  no_of_columns?: number | null,
  column_description?: string | null,
  scenario_display_name?: string | null,
  scenario_period?: string | null,
  block_id?: number | null,
  footnotes?: Array< number | null > | null,
  comparison_scenario?: string | null,
  comparison_scenario_period?: string | null,
  fx_scenario?: string | null,
  fx_scenario_period?: string | null,
  denominator_scenario?: string | null,
  denominator_scenario_period?: string | null,
  block_header?: string | null,
  non_material_flag?: string | null,
  denominator_kpi_exception_flag?: string | null,
  column_mapping_group?: string | null,
  report_header?: string | null,
  time_grain?: string | null,
  deck_cycle?: string | null,
};

export type DeckColumnDeleteItemsInput = {
  page_id: string,
  deckcolumn_id: string,
};

export type FootnoteOperationsInput = {
  create?: Array< FootnoteItemsInput | null > | null,
  update?: Array< FootnoteItemsInput | null > | null,
  delete?: Array< FootnoteDeleteItemsInput | null > | null,
};

export type FootnoteItemsInput = {
  footnote_id: string,
  page_id: string,
  footnote_no?: string | null,
  footnote_description?: string | null,
};

export type FootnoteDeleteItemsInput = {
  footnote_id: string,
  page_id: string,
};

export type KPIOperationsInput = {
  create?: Array< KPIItemsInput | null > | null,
  update?: Array< KPIItemsInput | null > | null,
  delete?: Array< KPIDeleteItemsInput | null > | null,
};

export type KPIItemsInput = {
  kpi_id: string,
  is_calculated_kpi?: CalculatedKPIValues | null,
  kpi_formula?: string | null,
  kpi_map?: GalaxyKPIDriversInput | null,
};

export type KPIDeleteItemsInput = {
  kpi_id: string,
};

export type PageOperationsInput = {
  create?: Array< PageItemsInput | null > | null,
  update?: Array< PageItemsInput | null > | null,
  delete?: Array< PageDeleteItemsInput | null > | null,
};

export type PageItemsInput = {
  page_id: string,
  page_name?: string | null,
  page_grain?: string | null,
  page_no?: number | null,
  page_drivers?: Array< KPIDriversInput | null > | null,
  previous_page_id?: string | null,
  next_page_id?: string | null,
  page_type?: string | null,
  denominator_label?: DenominatorLabelValues | null,
  scale?: PageScaleValues | null,
  layout_family?: string | null,
  report_header?: string | null,
};

export type PageDeleteItemsInput = {
  page_id: string,
};

export type ScenarioManagementOperationsInput = {
  create?: Array< ScenarioManagementItemsInput | null > | null,
  update?: Array< ScenarioManagementItemsInput | null > | null,
  delete?: Array< ScenarioManagementDeleteItemsInput | null > | null,
};

export type ScenarioManagementItemsInput = {
  scenario_id: string,
  deck_cycle?: string | null,
  month?: string | null,
  page_name?: string | null,
  sno?: string | null,
  page_no?: string | null,
  is_external_page?: boolean | null,
  page_grain?: string | null,
  schedule_type: ScheduleType,
  is_supplemental?: boolean | null,
  is_blankpage?: boolean | null,
  toc_sno?: string | null,
  toc_page_no?: string | null,
};

export type ScenarioManagementDeleteItemsInput = {
  scenario_id: string,
  schedule_type: ScheduleType,
};

export type AuditHistoryOperationsInput = {
  create?: Array< AuditHistoryItemsInput | null > | null,
};

export type AuditHistoryItemsInput = {
  page_id: string,
  change_type?: string | null,
  before?: string | null,
  after?: string | null,
  user?: string | null,
  dateTime?: string | null,
  row?: string | null,
  page_name?: string | null,
};

export type PublishDeckInput = {
  deck_id: string,
  publish_id: string,
  publish_timestamp?: string | null,
  schedule_type: ScheduleType,
  month?: string | null,
  deck_cycle: string,
  publish_iteration_type?: PublishIterationType | null,
};

export enum PublishIterationType {
  DEFAULT = "DEFAULT",
  AWS_REFRESH = "AWS_REFRESH",
}


export type UpdateDeckInput = {
  deck_id: string,
  publish_status?: PublishStatus | null,
  last_updated_date?: string | null,
  has_active_system_run?: boolean | null,
  deck_cycle?: string | null,
  enabled_page_grains?: Array< string | null > | null,
  enabled_datasets?: Array< DatasetSource | null > | null,
};

export type LockEvent = {
  __typename: "LockEvent",
  deck_id: string,
  page_name?: string | null,
  locked_by?: string | null,
  locked_at?: string | null,
  lock_expiry?: string | null,
  lock_scope: LockScope,
};

export enum LockScope {
  DECK = "DECK",
  PAGE = "PAGE",
}


export type CreateRootKPIInput = {
  root_kpi_id: string,
  root_kpi_name: string,
  kpi_type: KPIType,
};

export type RootKPI = {
  __typename: "RootKPI",
  pk: string,
  sk: string,
  root_kpi_id: string,
  root_kpi_name: string,
  kpi_type: KPIType,
  variants?:  Array<KPIVariant | null > | null,
  created_date?: string | null,
  created_by?: string | null,
  last_updated_date?: string | null,
  last_updated_by?: string | null,
};

export type KPIVariant = {
  __typename: "KPIVariant",
  pk: string,
  sk: string,
  kpi_variant_id: string,
  variant_name: string,
  variant_overrides?: KPIDrivers | null,
  dataset_source?: DatasetSource | null,
  kpi_type: KPIType,
  root_kpi_id: string,
  created_date?: string | null,
  last_updated_date?: string | null,
  created_by?: string | null,
  last_updated_by?: string | null,
};

export type UpdateRootKPIInput = {
  root_kpi_id: string,
  root_kpi_name: string,
};

export type CreateKPIVariantInput = {
  root_kpi_id: string,
  kpi_variant_id: string,
  variant_name?: string | null,
  dataset_source?: DatasetSource | null,
  variant_overrides: Array< KPIDriverEntryInput >,
  kpi_type: KPIType,
};

export type KPIDriverEntryInput = {
  key: string,
  value: string,
};

export type UpdateKPIVariantInput = {
  root_kpi_id: string,
  kpi_variant_id: string,
  variant_name?: string | null,
  dataset_source?: DatasetSource | null,
  variant_overrides?: Array< KPIDriverEntryInput > | null,
};

export type UpdateKPIVariantResponse = {
  __typename: "UpdateKPIVariantResponse",
  pk: string,
  sk: string,
  kpi_variant_id: string,
  variant_name: string,
  variant_overrides?: KPIDrivers | null,
  dataset_source?: DatasetSource | null,
  kpi_type: KPIType,
  root_kpi_id: string,
  created_date?: string | null,
  last_updated_date?: string | null,
  created_by?: string | null,
  last_updated_by?: string | null,
  affected_page_ids?: Array< string | null > | null,
  updated_decklines?:  Array<Deckline | null > | null,
};

export type DeleteKPIVariantInput = {
  root_kpi_id: string,
  kpi_variant_id: string,
};

export type DeleteKPIVariantResponse = {
  __typename: "DeleteKPIVariantResponse",
  kpi_variant_id: string,
  root_kpi_id: string,
  root_kpi_auto_deleted: boolean,
  affected_page_ids?: Array< string | null > | null,
  deleted_decklines?:  Array<Deckline | null > | null,
  reordered_decklines?:  Array<Deckline | null > | null,
};

export type SaveColumnTemplateInput = {
  deck_id: string,
  layout_family: string,
  grain: string,
  deck_cycle?: string | null,
  name?: string | null,
  header_tree: Array< HeaderRootNodeInput >,
  expected_template_version?: string | null,
};

export type HeaderRootNodeInput = {
  group?: HeaderGroupInput | null,
  block?: HeaderBlockInput | null,
  section?: HeaderSectionInput | null,
};

export type HeaderGroupInput = {
  nodeId: string,
  kind: HeaderNodeKind,
  label: string,
  footnotes?: Array< number | null > | null,
  children: Array< HeaderBlockInput >,
};

export enum HeaderNodeKind {
  SECTION = "SECTION",
  GROUP = "GROUP",
  BLOCK = "BLOCK",
  LEAF = "LEAF",
}


export type HeaderBlockInput = {
  nodeId: string,
  kind: HeaderNodeKind,
  label?: string | null,
  blockId: number,
  measure: string,
  scenario?: string | null,
  periodToken?: string | null,
  timeGrain?: string | null,
  nonMaterial?: boolean | null,
  scenarioPlacement?: HeaderPlacement | null,
  periodPlacement?: HeaderPlacement | null,
  dimensionOverrides?: GalaxyKPIDriversInput | null,
  datasetSource?: DatasetSource | null,
  footnotes?: Array< number | null > | null,
  children: Array< HeaderLeafInput >,
};

export enum HeaderPlacement {
  BAND = "BAND",
  LEAF = "LEAF",
}


export type HeaderLeafInput = {
  nodeId: string,
  kind: HeaderNodeKind,
  label?: string | null,
  columnNo: number,
  measure?: string | null,
  scenario?: string | null,
  periodToken?: string | null,
  timeGrain?: string | null,
  dimensionOverrides?: GalaxyKPIDriversInput | null,
  format?: LeafFormatInput | null,
  calculation?: ColumnCalculationInput | null,
  footnotes?: Array< number | null > | null,
};

export type LeafFormatInput = {
  cellDefault?: CellFormat | null,
};

export type ColumnCalculationInput = {
  type: ColumnCalculationType,
  operands: Array< string >,
};

export enum ColumnCalculationType {
  CPH = "CPH",
  VARIANCE = "VARIANCE",
  PCT_CHANGE = "PCT_CHANGE",
  SEQ_GROWTH_PCT = "SEQ_GROWTH_PCT",
}


export type HeaderSectionInput = {
  nodeId: string,
  kind: HeaderNodeKind,
  label?: string | null,
  footnotes?: Array< number | null > | null,
  children: Array< HeaderRootNodeInput >,
};

export type LayoutTemplate = {
  __typename: "LayoutTemplate",
  pk: string,
  sk: string,
  deckColumnGSI_pk?: string | null,
  deckColumnGSI_sk?: string | null,
  deck_id?: string | null,
  layout_family?: string | null,
  deck_cycle?: string | null,
  grain?: string | null,
  name?: string | null,
  header_tree?:  Array<StoredHeaderRoot | null > | null,
  template_version?: string | null,
  created_by?: string | null,
  created_date?: string | null,
  last_updated_by?: string | null,
  last_updated_date?: string | null,
};

export type StoredHeaderRoot = SectionNode | GroupNode | BlockNode


export type SectionNode = {
  __typename: "SectionNode",
  nodeId?: string | null,
  kind?: HeaderNodeKind | null,
  label?: string | null,
  footnotes?: Array< number | null > | null,
  children?:  Array<HeaderRootNode | null > | null,
};

// A block root: a grouping band or a BLOCK directly. Unions carry no auth directives (AppSync
// rejects them on unions); auth rides the member types. The Lambda must emit `__typename` on
// every node so AppSync can resolve the union.
export type HeaderRootNode = GroupNode | BlockNode


export type GroupNode = {
  __typename: "GroupNode",
  nodeId?: string | null,
  kind?: HeaderNodeKind | null,
  label?: string | null,
  footnotes?: Array< number | null > | null,
  children?:  Array<BlockNode | null > | null,
};

export type BlockNode = {
  __typename: "BlockNode",
  nodeId?: string | null,
  kind?: HeaderNodeKind | null,
  label?: string | null,
  footnotes?: Array< number | null > | null,
  // --- authored on the node, round-trips into HeaderBlockInput ---
  blockId?: number | null,
  measure?: string | null,
  scenario?: string | null,
  periodToken?: string | null,
  timeGrain?: string | null,
  nonMaterial?: boolean | null,
  dimensionOverrides?: GalaxyKPIDrivers | null,
  datasetSource?: DatasetSource | null,
  // --- derived per request, never stored ---
  resolvedScenario?: string | null,
  resolvedPeriod?: string | null,
  scenarioPlacement?: HeaderPlacement | null,
  periodPlacement?: HeaderPlacement | null,
  periodOwnedByLeaves?: boolean | null,
  bandPeriod?: string | null,
  children?:  Array<LeafNode | null > | null,
};

export type LeafNode = {
  __typename: "LeafNode",
  nodeId?: string | null,
  kind?: HeaderNodeKind | null,
  label?: string | null,
  footnotes?: Array< number | null > | null,
  // --- authored on the node, round-trips into HeaderLeafInput ---
  columnNo?: number | null,
  measure?: string | null,
  scenario?: string | null,
  periodToken?: string | null,
  timeGrain?: string | null,
  dimensionOverrides?: GalaxyKPIDrivers | null,
  format?: LeafFormat | null,
  calculation?: ColumnCalculation | null,
  // --- derived per request, never stored ---
  colKey?: string | null,
  excelLetter?: string | null,
  resolvedScenario?: string | null,
  resolvedPeriod?: string | null,
};

export type LeafFormat = {
  __typename: "LeafFormat",
  cellDefault?: CellFormat | null,
};

export type ColumnCalculation = {
  __typename: "ColumnCalculation",
  type?: ColumnCalculationType | null,
  operands?: Array< string | null > | null,
};

export type SaveCalcDefinitionInput = {
  deck_id: string,
  stem_kpi_id: string,
  kpi_formula_template: string,
  kpi_operands: Array< CalcOperandInput >,
  dataset_source?: DatasetSource | null,
  expected_version?: string | null,
};

export type CalcOperandInput = {
  ref: string,
  kind: CalcOperandKind,
  overrides?: KPIDriversInput | null,
  deckline_id?: string | null,
  root_kpi_id?: string | null,
  kpi_variant_id?: string | null,
  kpi_id?: string | null,
};

export enum CalcOperandKind {
  ROW = "ROW",
  VARIANT = "VARIANT",
  SHIFT = "SHIFT",
  PINNED = "PINNED",
}


export type CalcDefinition = {
  __typename: "CalcDefinition",
  pk: string,
  sk: string,
  deck_id?: string | null,
  stem_kpi_id?: string | null,
  kpi_formula_template?: string | null,
  kpi_operands?:  Array<CalcOperand | null > | null,
  dataset_source?: DatasetSource | null,
  last_updated_by?: string | null,
  last_updated_date?: string | null,
};

export type CalcOperand = {
  __typename: "CalcOperand",
  ref?: string | null,
  kind?: CalcOperandKind | null,
  overrides?: KPIDrivers | null,
  deckline_id?: string | null,
  root_kpi_id?: string | null,
  kpi_variant_id?: string | null,
  kpi_id?: string | null,
};

export type AuditHistoryPaginatedResponse = {
  __typename: "AuditHistoryPaginatedResponse",
  items?:  Array<AuditHistory | null > | null,
  nextToken?: string | null,
};

export type AuditHistory = {
  __typename: "AuditHistory",
  pk: string,
  sk: string,
  change_type?: string | null,
  before?: string | null,
  after?: string | null,
  user?: string | null,
  dateTime?: string | null,
  row?: string | null,
  page_name?: string | null,
};

export type DeckColumnPaginatedResponse = {
  __typename: "DeckColumnPaginatedResponse",
  items?:  Array<DeckColumn | null > | null,
  nextToken?: string | null,
};

export type KPIPaginatedResponse = {
  __typename: "KPIPaginatedResponse",
  items?:  Array<KPI | null > | null,
  nextToken?: string | null,
};

export type RootKPIPaginatedResponse = {
  __typename: "RootKPIPaginatedResponse",
  items?:  Array<RootKPI | null > | null,
  nextToken?: string | null,
};

export type KPIUsageSummary = {
  __typename: "KPIUsageSummary",
  root_kpi_id: string,
  root_kpi_name: string,
  total_deckline_count: number,
  total_page_count: number,
  total_core_page_count: number,
  total_deck_count: number,
  deck_usage:  Array<DeckUsageDetail | null >,
};

export type DeckUsageDetail = {
  __typename: "DeckUsageDetail",
  deck_id: string,
  deck_name: string,
  page_usage:  Array<CorePageUsageDetail | null >,
};

export type CorePageUsageDetail = {
  __typename: "CorePageUsageDetail",
  core_page_name: string,
  pages:  Array<PageUsageDetail | null >,
};

export type PageUsageDetail = {
  __typename: "PageUsageDetail",
  page_id: string,
  page_name: string,
  deckline_count: number,
  kpi_variant_ids: Array< string | null >,
};

export type KPIHierarchyAuditEntityInput = {
  entity_type: KPIHierarchyAuditEntityType,
  entity_id: string,
};

export enum KPIHierarchyAuditEntityType {
  ROOT_KPI = "ROOT_KPI",
  KPI_VARIANT = "KPI_VARIANT",
}


export type PageLayout = {
  __typename: "PageLayout",
  pageId: string,
  sections?:  Array<PageLayoutSection | null > | null,
  footnotes?: Array< number | null > | null,
  layoutVersion?: string | null,
  templateVersion?: string | null,
  resolvedDeckCycle?: string | null,
  resolvedTemplateCycle?: string | null,
};

export type PageLayoutSection = {
  __typename: "PageLayoutSection",
  sectionId?: string | null,
  label?: string | null,
  columnHeaderTree?:  Array<HeaderRootNode | null > | null,
  columns?:  Array<ColumnLeaf | null > | null,
};

export type ColumnLeaf = {
  __typename: "ColumnLeaf",
  colKey: string,
  excelLetter?: string | null,
  blockId?: number | null,
  columnNo?: number | null,
  label?: string | null,
  measure?: string | null,
  blockLabel?: string | null,
  blockFootnotes?: Array< number | null > | null,
  groupId?: number | null,
  groupLabel?: string | null,
  groupFootnotes?: Array< number | null > | null,
  scenarioDisplay?: string | null,
  scenarioPeriod?: string | null,
  timeGrain?: string | null,
  nonMaterial?: boolean | null,
  operator?: ColumnOperator | null,
  operands?:  Array<ColumnOperand | null > | null,
  measureOverlays?:  Array<ColumnMeasureOverlay | null > | null,
  format?: LeafFormat | null,
  calculation?: ColumnCalculation | null,
  footnotes?: Array< number | null > | null,
  datasetSource?: DatasetSource | null,
  dimensionOverrides?: GalaxyKPIDrivers | null,
};

export enum ColumnOperator {
  VALUE = "VALUE",
  DIFFERENCE_EX_FX = "DIFFERENCE_EX_FX",
  DIFFERENCE_INCL_FX = "DIFFERENCE_INCL_FX",
  RATIO = "RATIO",
  CHANGE_RATE_EX_FX = "CHANGE_RATE_EX_FX",
  CHANGE_RATE_INCL_FX = "CHANGE_RATE_INCL_FX",
  DIFFERENCE = "DIFFERENCE",
}


export type ColumnOperand = {
  __typename: "ColumnOperand",
  role?: OperandRole | null,
  scenarioToken?: string | null,
  scenario?: string | null,
  periodToken?: string | null,
  period?: string | null,
  yearOffset?: number | null,
  monthOffset?: number | null,
};

export enum OperandRole {
  BASE = "BASE",
  COMPARISON = "COMPARISON",
  FX = "FX",
  DENOMINATOR = "DENOMINATOR",
}


export type ColumnMeasureOverlay = {
  __typename: "ColumnMeasureOverlay",
  measure: string,
  operator?: ColumnOperator | null,
  operands?:  Array<ColumnOperand | null > | null,
  terms?:  Array<ColumnMeasureTerm | null > | null,
};

export type ColumnMeasureTerm = {
  __typename: "ColumnMeasureTerm",
  role: OperandRole,
  operator?: ColumnOperator | null,
  operands?:  Array<ColumnOperand | null > | null,
};

export type LayoutTemplateCatalogPage = {
  __typename: "LayoutTemplateCatalogPage",
  items?:  Array<LayoutTemplateSummary | null > | null,
  nextToken?: string | null,
};

export type LayoutTemplateSummary = {
  __typename: "LayoutTemplateSummary",
  pk?: string | null,
  sk?: string | null,
  layout_family?: string | null,
  deck_cycle?: string | null,
  grain?: string | null,
  name?: string | null,
  template_version?: string | null,
  last_updated_by?: string | null,
  last_updated_date?: string | null,
  node_counts?: NodeCounts | null,
};

export type NodeCounts = {
  __typename: "NodeCounts",
  groups?: number | null,
  blocks?: number | null,
  leaves?: number | null,
};

export type CreateDeckMutationVariables = {
  userAlias: string,
  request: CreateDeckInput,
};

export type CreateDeckMutation = {
  createDeck?:  {
    __typename: "Deck",
    pk: string,
    sk: string,
    deckGSI_pk?: string | null,
    deckGSI_sk?: string | null,
    deck_name?: string | null,
    created_date?: string | null,
    last_updated_date?: string | null,
    created_by?: string | null,
    last_updated_by?: string | null,
    current_user?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    publish_status?: PublishStatus | null,
    publish_user?: string | null,
    publish_deck_cycle?: string | null,
    has_active_system_run?: boolean | null,
    last_publish_date?: string | null,
    publish_timestamp?: string | null,
    deck_cycle?: string | null,
    enabled_page_grains?: Array< string | null > | null,
    enabled_datasets?: Array< DatasetSource | null > | null,
  } | null,
};

export type CreateTOCEntryMutationVariables = {
  userAlias: string,
  request: CreateTOCEntryInput,
};

export type CreateTOCEntryMutation = {
  createTOCEntry?:  {
    __typename: "TOCEntry",
    pk: string,
    sk: string,
    toc_id: string,
    page_id?: string | null,
    page_no?: string | null,
    toc_page_name?: string | null,
    page_name?: string | null,
    is_visible?: boolean | null,
    is_active?: boolean | null,
    group_name?: string | null,
    serial_no?: number | null,
    created_date?: string | null,
    last_updated_date?: string | null,
    schedule_type?: ScheduleType | null,
  } | null,
};

export type CreateScenarioManagementEntryMutationVariables = {
  userAlias: string,
  request: CreateScenarioManagementEntryInput,
};

export type CreateScenarioManagementEntryMutation = {
  createScenarioManagementEntry?:  {
    __typename: "ScenarioManagementEntry",
    pk: string,
    sk: string,
    scenario_id: string,
    deck_cycle?: string | null,
    month?: string | null,
    page_name?: string | null,
    page_no?: string | null,
    sno?: string | null,
    is_external_page?: boolean | null,
    page_grain?: string | null,
    schedule_type: ScheduleType,
    last_updated_date?: string | null,
    is_supplemental?: boolean | null,
    is_blankpage?: boolean | null,
    toc_sno?: string | null,
    toc_page_no?: string | null,
  } | null,
};

export type CreatePageMutationVariables = {
  userAlias: string,
  request: CreatePageInput,
};

export type CreatePageMutation = {
  createPage?:  {
    __typename: "Page",
    pk: string,
    sk: string,
    pageGSI_pk?: string | null,
    pageGSI_sk?: string | null,
    page_name?: string | null,
    deck_id?: string | null,
    page_grain?: string | null,
    page_no?: number | null,
    page_drivers:  Array<( {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        account_hierarchy?: string | null,
        account?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costpool?: string | null,
      } | {
        __typename: "HctrKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        measure_hierarchy?: string | null,
        measure?: string | null,
        transferDirection_hierarchy?: string | null,
        transferDirection?: string | null,
        workflow_hierarchy?: string | null,
        workflow?: string | null,
      }
    ) | null > | null,
    previous_page_id?: string | null,
    next_page_id?: string | null,
    page_type?: string | null,
    denominator_label?: DenominatorLabelValues | null,
    scale?: PageScaleValues | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    layout_family?: string | null,
    report_header?: string | null,
  } | null,
};

export type CreateDecklineMutationVariables = {
  userAlias: string,
  request: CreateDecklineInput,
};

export type CreateDecklineMutation = {
  createDeckline?:  {
    __typename: "Deckline",
    calc_members?:  {
      __typename: "CalcExpression",
      dimension?: string | null,
      tokens?:  Array< {
        __typename: "CalcToken",
        kind?: CalcTokenKind | null,
        value?: string | null,
      } | null > | null,
      pins?:  Array< {
        __typename: "CalcPin",
        dimension?: string | null,
        node?: string | null,
      } | null > | null,
    } | null,
    pk: string,
    sk: string,
    page_name?: string | null,
    kpi_id?: string | null,
    kpi_id_by_override?:  Array< {
      __typename: "DecklineCellKpiId",
      override_set?:  {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
        fieldtype?: string | null,
      } | null,
      kpi_id: string,
    } | null > | null,
    kpi_name?: string | null,
    kpi_formula?: string | null,
    serial_no?: string | null,
    is_code_or_description?: CodeOrDescription | null,
    is_format_bold?: boolean | null,
    is_format_italics?: boolean | null,
    is_format_underline?: boolean | null,
    format_text_color?: string | null,
    format_cell_color?: string | null,
    format_cell_default?: CellFormat | null,
    format_cell_overrides?:  Array< {
      __typename: "DecklineCellFormat",
      colKey: string,
      format: CellFormat,
    } | null > | null,
    blankline_type?: BlanklineType | null,
    is_format_borderline?: boolean | null,
    footnotes?: Array< number | null > | null,
    subtotal_formula?: string | null,
    subtotal_parent?: string | null,
    is_calculated_kpi?: CalculatedKPIValues | null,
    kpi_type?: KPIType | null,
    deckline_kind?: DecklineKind | null,
    deckline_drivers: ( {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        account_hierarchy?: string | null,
        account?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costpool?: string | null,
      } | {
        __typename: "HctrKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        measure_hierarchy?: string | null,
        measure?: string | null,
        transferDirection_hierarchy?: string | null,
        transferDirection?: string | null,
        workflow_hierarchy?: string | null,
        workflow?: string | null,
      }
    ) | null,
    is_exception?: boolean | null,
    page_section?: string | null,
    column_template?: string | null,
    adjcalcflag?: boolean | null,
    exceptioncalculatedkpiflag?: boolean | null,
    bordertopflag?: boolean | null,
    borderrightflag?: boolean | null,
    borderbottomflag?: boolean | null,
    borderleftflag?: boolean | null,
    borderweightflag?: BorderWeight | null,
    textunderlineflag?: boolean | null,
    denominator_kpi_id_for_pct?: string | null,
    denominator_kpi_id_drivers?:  {
      __typename: "GalaxyKPIDrivers",
      datasetSource?: DatasetSource | null,
      account_hierarchy?: string | null,
      account?: string | null,
      location_hierarchy?: string | null,
      location?: string | null,
      project_hierarchy?: string | null,
      project?: string | null,
      company_hierarchy?: string | null,
      company?: string | null,
      product_hierarchy?: string | null,
      product?: string | null,
      revgp_hierarchy?: string | null,
      revgp?: string | null,
      datasource_hierarchy?: string | null,
      datasource?: string | null,
      channel_hierarchy?: string | null,
      channel?: string | null,
      costcenter_hierarchy?: string | null,
      costcenter?: string | null,
      costtype?: string | null,
      costpool?: string | null,
      fieldtype?: string | null,
    } | null,
    denominator_is_calculated_kpi?: CalculatedKPIValues | null,
    denominator_kpi_formula?: string | null,
    root_kpi_id?: string | null,
    kpi_variant_id?: string | null,
    display_name?: string | null,
    denominator_kpi_variant_id?: string | null,
    measure?: string | null,
    kpi_name_indent_level?: number | null,
    fxinclflag?: string | null,
    calcdivisionflag?: string | null,
    bps_override_flag?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      commentId: string,
      user: string,
      commentDesc: string,
      timestamp: string,
    } | null > | null,
  } | null,
};

export type CreateDeckColumnMutationVariables = {
  userAlias: string,
  request: CreateDeckColumnInput,
};

export type CreateDeckColumnMutation = {
  createDeckColumn?:  {
    __typename: "DeckColumn",
    pk: string,
    sk: string,
    deckColumnGSI_pk?: string | null,
    deckColumnGSI_sk?: string | null,
    deck_id?: string | null,
    column_template?: string | null,
    page_section?: string | null,
    column_no?: number | null,
    column_title?: string | null,
    column_name?: string | null,
    no_of_columns?: number | null,
    column_description?: string | null,
    scenario_display_name?: string | null,
    scenario_period?: string | null,
    block_id?: number | null,
    comparison_scenario?: string | null,
    comparison_scenario_period?: string | null,
    fx_scenario?: string | null,
    fx_scenario_period?: string | null,
    denominator_scenario?: string | null,
    denominator_scenario_period?: string | null,
    block_header?: string | null,
    non_material_flag?: string | null,
    denominator_kpi_exception_flag?: string | null,
    last_updated_date?: string | null,
    column_mapping_group?: string | null,
    report_header?: string | null,
    time_grain?: string | null,
    deck_cycle?: string | null,
  } | null,
};

export type CreateKPIMutationVariables = {
  userAlias: string,
  request: CreateKPIInput,
};

export type CreateKPIMutation = {
  createKPI?:  {
    __typename: "KPI",
    pk: string,
    sk: string,
    is_calculated_kpi?: CalculatedKPIValues | null,
    kpi_type?: KPIType | null,
    kpi_formula?: string | null,
    kpi_map: ( {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        account_hierarchy?: string | null,
        account?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costpool?: string | null,
      } | {
        __typename: "HctrKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        measure_hierarchy?: string | null,
        measure?: string | null,
        transferDirection_hierarchy?: string | null,
        transferDirection?: string | null,
        workflow_hierarchy?: string | null,
        workflow?: string | null,
      }
    ) | null,
    last_updated_date?: string | null,
  } | null,
};

export type CreateFootnoteMutationVariables = {
  userAlias: string,
  request: CreateFootnoteInput,
};

export type CreateFootnoteMutation = {
  createFootnote?:  {
    __typename: "Footnote",
    pk: string,
    sk: string,
    footnote_no?: string | null,
    footnote_description?: string | null,
  } | null,
};

export type SaveDeckMutationVariables = {
  userAlias?: string | null,
  request: SaveDeckInput,
};

export type SaveDeckMutation = {
  saveDeck?: boolean | null,
};

export type PublishDeckMutationVariables = {
  userAlias?: string | null,
  request: PublishDeckInput,
};

export type PublishDeckMutation = {
  publishDeck?: boolean | null,
};

export type UpdateDeckMutationVariables = {
  userAlias: string,
  request: UpdateDeckInput,
};

export type UpdateDeckMutation = {
  updateDeck?:  {
    __typename: "Deck",
    pk: string,
    sk: string,
    deckGSI_pk?: string | null,
    deckGSI_sk?: string | null,
    deck_name?: string | null,
    created_date?: string | null,
    last_updated_date?: string | null,
    created_by?: string | null,
    last_updated_by?: string | null,
    current_user?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    publish_status?: PublishStatus | null,
    publish_user?: string | null,
    publish_deck_cycle?: string | null,
    has_active_system_run?: boolean | null,
    last_publish_date?: string | null,
    publish_timestamp?: string | null,
    deck_cycle?: string | null,
    enabled_page_grains?: Array< string | null > | null,
    enabled_datasets?: Array< DatasetSource | null > | null,
  } | null,
};

export type UpdateSystemRunStatusMutationVariables = {
  userAlias: string,
  has_active_system_run: boolean,
};

export type UpdateSystemRunStatusMutation = {
  updateSystemRunStatus?: boolean | null,
};

export type LockDeckMutationVariables = {
  deck_id: string,
  userAlias?: string | null,
};

export type LockDeckMutation = {
  lockDeck?:  {
    __typename: "LockEvent",
    deck_id: string,
    page_name?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    lock_scope: LockScope,
  } | null,
};

export type ReleaseDeckLockMutationVariables = {
  deck_id: string,
  userAlias?: string | null,
  expected_schedule_name?: string | null,
};

export type ReleaseDeckLockMutation = {
  releaseDeckLock?:  {
    __typename: "LockEvent",
    deck_id: string,
    page_name?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    lock_scope: LockScope,
  } | null,
};

export type LockPageMutationVariables = {
  deck_id: string,
  page_name: string,
  userAlias?: string | null,
};

export type LockPageMutation = {
  lockPage?:  {
    __typename: "LockEvent",
    deck_id: string,
    page_name?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    lock_scope: LockScope,
  } | null,
};

export type ReleasePageLockMutationVariables = {
  deck_id: string,
  page_name: string,
  userAlias?: string | null,
  expected_schedule_name?: string | null,
};

export type ReleasePageLockMutation = {
  releasePageLock?:  {
    __typename: "LockEvent",
    deck_id: string,
    page_name?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    lock_scope: LockScope,
  } | null,
};

export type CreateRootKPIMutationVariables = {
  userAlias?: string | null,
  request: CreateRootKPIInput,
};

export type CreateRootKPIMutation = {
  createRootKPI?:  {
    __typename: "RootKPI",
    pk: string,
    sk: string,
    root_kpi_id: string,
    root_kpi_name: string,
    kpi_type: KPIType,
    variants?:  Array< {
      __typename: "KPIVariant",
      pk: string,
      sk: string,
      kpi_variant_id: string,
      variant_name: string,
      variant_overrides: ( {
          __typename: "GalaxyKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          account_hierarchy?: string | null,
          account?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costpool?: string | null,
        } | {
          __typename: "HctrKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          measure_hierarchy?: string | null,
          measure?: string | null,
          transferDirection_hierarchy?: string | null,
          transferDirection?: string | null,
          workflow_hierarchy?: string | null,
          workflow?: string | null,
        }
      ) | null,
      dataset_source?: DatasetSource | null,
      kpi_type: KPIType,
      root_kpi_id: string,
      created_date?: string | null,
      last_updated_date?: string | null,
      created_by?: string | null,
      last_updated_by?: string | null,
    } | null > | null,
    created_date?: string | null,
    created_by?: string | null,
    last_updated_date?: string | null,
    last_updated_by?: string | null,
  } | null,
};

export type UpdateRootKPIMutationVariables = {
  userAlias?: string | null,
  request: UpdateRootKPIInput,
};

export type UpdateRootKPIMutation = {
  updateRootKPI?:  {
    __typename: "RootKPI",
    pk: string,
    sk: string,
    root_kpi_id: string,
    root_kpi_name: string,
    kpi_type: KPIType,
    variants?:  Array< {
      __typename: "KPIVariant",
      pk: string,
      sk: string,
      kpi_variant_id: string,
      variant_name: string,
      variant_overrides: ( {
          __typename: "GalaxyKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          account_hierarchy?: string | null,
          account?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costpool?: string | null,
        } | {
          __typename: "HctrKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          measure_hierarchy?: string | null,
          measure?: string | null,
          transferDirection_hierarchy?: string | null,
          transferDirection?: string | null,
          workflow_hierarchy?: string | null,
          workflow?: string | null,
        }
      ) | null,
      dataset_source?: DatasetSource | null,
      kpi_type: KPIType,
      root_kpi_id: string,
      created_date?: string | null,
      last_updated_date?: string | null,
      created_by?: string | null,
      last_updated_by?: string | null,
    } | null > | null,
    created_date?: string | null,
    created_by?: string | null,
    last_updated_date?: string | null,
    last_updated_by?: string | null,
  } | null,
};

export type DeleteRootKPIMutationVariables = {
  userAlias?: string | null,
  root_kpi_id: string,
};

export type DeleteRootKPIMutation = {
  deleteRootKPI?: boolean | null,
};

export type CreateKPIVariantMutationVariables = {
  userAlias?: string | null,
  request: CreateKPIVariantInput,
};

export type CreateKPIVariantMutation = {
  createKPIVariant?:  {
    __typename: "KPIVariant",
    pk: string,
    sk: string,
    kpi_variant_id: string,
    variant_name: string,
    variant_overrides: ( {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        account_hierarchy?: string | null,
        account?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costpool?: string | null,
      } | {
        __typename: "HctrKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        measure_hierarchy?: string | null,
        measure?: string | null,
        transferDirection_hierarchy?: string | null,
        transferDirection?: string | null,
        workflow_hierarchy?: string | null,
        workflow?: string | null,
      }
    ) | null,
    dataset_source?: DatasetSource | null,
    kpi_type: KPIType,
    root_kpi_id: string,
    created_date?: string | null,
    last_updated_date?: string | null,
    created_by?: string | null,
    last_updated_by?: string | null,
  } | null,
};

export type UpdateKPIVariantMutationVariables = {
  userAlias?: string | null,
  request: UpdateKPIVariantInput,
};

export type UpdateKPIVariantMutation = {
  updateKPIVariant?:  {
    __typename: "UpdateKPIVariantResponse",
    pk: string,
    sk: string,
    kpi_variant_id: string,
    variant_name: string,
    variant_overrides: ( {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        account_hierarchy?: string | null,
        account?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costpool?: string | null,
      } | {
        __typename: "HctrKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        measure_hierarchy?: string | null,
        measure?: string | null,
        transferDirection_hierarchy?: string | null,
        transferDirection?: string | null,
        workflow_hierarchy?: string | null,
        workflow?: string | null,
      }
    ) | null,
    dataset_source?: DatasetSource | null,
    kpi_type: KPIType,
    root_kpi_id: string,
    created_date?: string | null,
    last_updated_date?: string | null,
    created_by?: string | null,
    last_updated_by?: string | null,
    affected_page_ids?: Array< string | null > | null,
    updated_decklines?:  Array< {
      __typename: "Deckline",
      calc_members?:  {
        __typename: "CalcExpression",
        dimension?: string | null,
        tokens?:  Array< {
          __typename: "CalcToken",
          kind?: CalcTokenKind | null,
          value?: string | null,
        } | null > | null,
        pins?:  Array< {
          __typename: "CalcPin",
          dimension?: string | null,
          node?: string | null,
        } | null > | null,
      } | null,
      pk: string,
      sk: string,
      page_name?: string | null,
      kpi_id?: string | null,
      kpi_id_by_override?:  Array< {
        __typename: "DecklineCellKpiId",
        override_set?:  {
          __typename: "GalaxyKPIDrivers",
          datasetSource?: DatasetSource | null,
          account_hierarchy?: string | null,
          account?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          company_hierarchy?: string | null,
          company?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          costpool?: string | null,
          fieldtype?: string | null,
        } | null,
        kpi_id: string,
      } | null > | null,
      kpi_name?: string | null,
      kpi_formula?: string | null,
      serial_no?: string | null,
      is_code_or_description?: CodeOrDescription | null,
      is_format_bold?: boolean | null,
      is_format_italics?: boolean | null,
      is_format_underline?: boolean | null,
      format_text_color?: string | null,
      format_cell_color?: string | null,
      format_cell_default?: CellFormat | null,
      format_cell_overrides?:  Array< {
        __typename: "DecklineCellFormat",
        colKey: string,
        format: CellFormat,
      } | null > | null,
      blankline_type?: BlanklineType | null,
      is_format_borderline?: boolean | null,
      footnotes?: Array< number | null > | null,
      subtotal_formula?: string | null,
      subtotal_parent?: string | null,
      is_calculated_kpi?: CalculatedKPIValues | null,
      kpi_type?: KPIType | null,
      deckline_kind?: DecklineKind | null,
      deckline_drivers: ( {
          __typename: "GalaxyKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          account_hierarchy?: string | null,
          account?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costpool?: string | null,
        } | {
          __typename: "HctrKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          measure_hierarchy?: string | null,
          measure?: string | null,
          transferDirection_hierarchy?: string | null,
          transferDirection?: string | null,
          workflow_hierarchy?: string | null,
          workflow?: string | null,
        }
      ) | null,
      is_exception?: boolean | null,
      page_section?: string | null,
      column_template?: string | null,
      adjcalcflag?: boolean | null,
      exceptioncalculatedkpiflag?: boolean | null,
      bordertopflag?: boolean | null,
      borderrightflag?: boolean | null,
      borderbottomflag?: boolean | null,
      borderleftflag?: boolean | null,
      borderweightflag?: BorderWeight | null,
      textunderlineflag?: boolean | null,
      denominator_kpi_id_for_pct?: string | null,
      denominator_kpi_id_drivers?:  {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
        fieldtype?: string | null,
      } | null,
      denominator_is_calculated_kpi?: CalculatedKPIValues | null,
      denominator_kpi_formula?: string | null,
      root_kpi_id?: string | null,
      kpi_variant_id?: string | null,
      display_name?: string | null,
      denominator_kpi_variant_id?: string | null,
      measure?: string | null,
      kpi_name_indent_level?: number | null,
      fxinclflag?: string | null,
      calcdivisionflag?: string | null,
      bps_override_flag?: string | null,
      comments?:  Array< {
        __typename: "Comment",
        commentId: string,
        user: string,
        commentDesc: string,
        timestamp: string,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type DeleteKPIVariantMutationVariables = {
  userAlias?: string | null,
  request: DeleteKPIVariantInput,
};

export type DeleteKPIVariantMutation = {
  deleteKPIVariant?:  {
    __typename: "DeleteKPIVariantResponse",
    kpi_variant_id: string,
    root_kpi_id: string,
    root_kpi_auto_deleted: boolean,
    affected_page_ids?: Array< string | null > | null,
    deleted_decklines?:  Array< {
      __typename: "Deckline",
      calc_members?:  {
        __typename: "CalcExpression",
        dimension?: string | null,
        tokens?:  Array< {
          __typename: "CalcToken",
          kind?: CalcTokenKind | null,
          value?: string | null,
        } | null > | null,
        pins?:  Array< {
          __typename: "CalcPin",
          dimension?: string | null,
          node?: string | null,
        } | null > | null,
      } | null,
      pk: string,
      sk: string,
      page_name?: string | null,
      kpi_id?: string | null,
      kpi_id_by_override?:  Array< {
        __typename: "DecklineCellKpiId",
        override_set?:  {
          __typename: "GalaxyKPIDrivers",
          datasetSource?: DatasetSource | null,
          account_hierarchy?: string | null,
          account?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          company_hierarchy?: string | null,
          company?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          costpool?: string | null,
          fieldtype?: string | null,
        } | null,
        kpi_id: string,
      } | null > | null,
      kpi_name?: string | null,
      kpi_formula?: string | null,
      serial_no?: string | null,
      is_code_or_description?: CodeOrDescription | null,
      is_format_bold?: boolean | null,
      is_format_italics?: boolean | null,
      is_format_underline?: boolean | null,
      format_text_color?: string | null,
      format_cell_color?: string | null,
      format_cell_default?: CellFormat | null,
      format_cell_overrides?:  Array< {
        __typename: "DecklineCellFormat",
        colKey: string,
        format: CellFormat,
      } | null > | null,
      blankline_type?: BlanklineType | null,
      is_format_borderline?: boolean | null,
      footnotes?: Array< number | null > | null,
      subtotal_formula?: string | null,
      subtotal_parent?: string | null,
      is_calculated_kpi?: CalculatedKPIValues | null,
      kpi_type?: KPIType | null,
      deckline_kind?: DecklineKind | null,
      deckline_drivers: ( {
          __typename: "GalaxyKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          account_hierarchy?: string | null,
          account?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costpool?: string | null,
        } | {
          __typename: "HctrKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          measure_hierarchy?: string | null,
          measure?: string | null,
          transferDirection_hierarchy?: string | null,
          transferDirection?: string | null,
          workflow_hierarchy?: string | null,
          workflow?: string | null,
        }
      ) | null,
      is_exception?: boolean | null,
      page_section?: string | null,
      column_template?: string | null,
      adjcalcflag?: boolean | null,
      exceptioncalculatedkpiflag?: boolean | null,
      bordertopflag?: boolean | null,
      borderrightflag?: boolean | null,
      borderbottomflag?: boolean | null,
      borderleftflag?: boolean | null,
      borderweightflag?: BorderWeight | null,
      textunderlineflag?: boolean | null,
      denominator_kpi_id_for_pct?: string | null,
      denominator_kpi_id_drivers?:  {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
        fieldtype?: string | null,
      } | null,
      denominator_is_calculated_kpi?: CalculatedKPIValues | null,
      denominator_kpi_formula?: string | null,
      root_kpi_id?: string | null,
      kpi_variant_id?: string | null,
      display_name?: string | null,
      denominator_kpi_variant_id?: string | null,
      measure?: string | null,
      kpi_name_indent_level?: number | null,
      fxinclflag?: string | null,
      calcdivisionflag?: string | null,
      bps_override_flag?: string | null,
      comments?:  Array< {
        __typename: "Comment",
        commentId: string,
        user: string,
        commentDesc: string,
        timestamp: string,
      } | null > | null,
    } | null > | null,
    reordered_decklines?:  Array< {
      __typename: "Deckline",
      calc_members?:  {
        __typename: "CalcExpression",
        dimension?: string | null,
        tokens?:  Array< {
          __typename: "CalcToken",
          kind?: CalcTokenKind | null,
          value?: string | null,
        } | null > | null,
        pins?:  Array< {
          __typename: "CalcPin",
          dimension?: string | null,
          node?: string | null,
        } | null > | null,
      } | null,
      pk: string,
      sk: string,
      page_name?: string | null,
      kpi_id?: string | null,
      kpi_id_by_override?:  Array< {
        __typename: "DecklineCellKpiId",
        override_set?:  {
          __typename: "GalaxyKPIDrivers",
          datasetSource?: DatasetSource | null,
          account_hierarchy?: string | null,
          account?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          company_hierarchy?: string | null,
          company?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          costpool?: string | null,
          fieldtype?: string | null,
        } | null,
        kpi_id: string,
      } | null > | null,
      kpi_name?: string | null,
      kpi_formula?: string | null,
      serial_no?: string | null,
      is_code_or_description?: CodeOrDescription | null,
      is_format_bold?: boolean | null,
      is_format_italics?: boolean | null,
      is_format_underline?: boolean | null,
      format_text_color?: string | null,
      format_cell_color?: string | null,
      format_cell_default?: CellFormat | null,
      format_cell_overrides?:  Array< {
        __typename: "DecklineCellFormat",
        colKey: string,
        format: CellFormat,
      } | null > | null,
      blankline_type?: BlanklineType | null,
      is_format_borderline?: boolean | null,
      footnotes?: Array< number | null > | null,
      subtotal_formula?: string | null,
      subtotal_parent?: string | null,
      is_calculated_kpi?: CalculatedKPIValues | null,
      kpi_type?: KPIType | null,
      deckline_kind?: DecklineKind | null,
      deckline_drivers: ( {
          __typename: "GalaxyKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          account_hierarchy?: string | null,
          account?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costpool?: string | null,
        } | {
          __typename: "HctrKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          measure_hierarchy?: string | null,
          measure?: string | null,
          transferDirection_hierarchy?: string | null,
          transferDirection?: string | null,
          workflow_hierarchy?: string | null,
          workflow?: string | null,
        }
      ) | null,
      is_exception?: boolean | null,
      page_section?: string | null,
      column_template?: string | null,
      adjcalcflag?: boolean | null,
      exceptioncalculatedkpiflag?: boolean | null,
      bordertopflag?: boolean | null,
      borderrightflag?: boolean | null,
      borderbottomflag?: boolean | null,
      borderleftflag?: boolean | null,
      borderweightflag?: BorderWeight | null,
      textunderlineflag?: boolean | null,
      denominator_kpi_id_for_pct?: string | null,
      denominator_kpi_id_drivers?:  {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
        fieldtype?: string | null,
      } | null,
      denominator_is_calculated_kpi?: CalculatedKPIValues | null,
      denominator_kpi_formula?: string | null,
      root_kpi_id?: string | null,
      kpi_variant_id?: string | null,
      display_name?: string | null,
      denominator_kpi_variant_id?: string | null,
      measure?: string | null,
      kpi_name_indent_level?: number | null,
      fxinclflag?: string | null,
      calcdivisionflag?: string | null,
      bps_override_flag?: string | null,
      comments?:  Array< {
        __typename: "Comment",
        commentId: string,
        user: string,
        commentDesc: string,
        timestamp: string,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type SaveColumnTemplateMutationVariables = {
  userAlias?: string | null,
  request: SaveColumnTemplateInput,
};

export type SaveColumnTemplateMutation = {
  saveColumnTemplate?:  {
    __typename: "LayoutTemplate",
    pk: string,
    sk: string,
    deckColumnGSI_pk?: string | null,
    deckColumnGSI_sk?: string | null,
    deck_id?: string | null,
    layout_family?: string | null,
    deck_cycle?: string | null,
    grain?: string | null,
    name?: string | null,
    header_tree:  Array<( {
        __typename: "SectionNode",
        nodeId?: string | null,
        kind?: HeaderNodeKind | null,
        label?: string | null,
        footnotes?: Array< number | null > | null,
        children:  Array<( {
            __typename: "GroupNode",
            nodeId?: string | null,
            kind?: HeaderNodeKind | null,
            label?: string | null,
            footnotes?: Array< number | null > | null,
            children?:  Array< {
              __typename: string,
              nodeId?: string | null,
              kind?: HeaderNodeKind | null,
              label?: string | null,
              footnotes?: Array< number | null > | null,
              // --- authored on the node, round-trips into HeaderBlockInput ---
              blockId?: number | null,
              measure?: string | null,
              scenario?: string | null,
              periodToken?: string | null,
              timeGrain?: string | null,
              nonMaterial?: boolean | null,
              dimensionOverrides?:  {
                __typename: string,
                datasetSource?: DatasetSource | null,
                account_hierarchy?: string | null,
                account?: string | null,
                location_hierarchy?: string | null,
                location?: string | null,
                project_hierarchy?: string | null,
                project?: string | null,
                company_hierarchy?: string | null,
                company?: string | null,
                product_hierarchy?: string | null,
                product?: string | null,
                revgp_hierarchy?: string | null,
                revgp?: string | null,
                datasource_hierarchy?: string | null,
                datasource?: string | null,
                channel_hierarchy?: string | null,
                channel?: string | null,
                costcenter_hierarchy?: string | null,
                costcenter?: string | null,
                costtype?: string | null,
                costpool?: string | null,
                fieldtype?: string | null,
              } | null,
              datasetSource?: DatasetSource | null,
              // --- derived per request, never stored ---
              resolvedScenario?: string | null,
              resolvedPeriod?: string | null,
              scenarioPlacement?: HeaderPlacement | null,
              periodPlacement?: HeaderPlacement | null,
              periodOwnedByLeaves?: boolean | null,
              bandPeriod?: string | null,
              children?:  Array< {
                __typename: string,
                nodeId?: string | null,
                kind?: HeaderNodeKind | null,
                label?: string | null,
                footnotes?: Array< number | null > | null,
                // --- authored on the node, round-trips into HeaderLeafInput ---
                columnNo?: number | null,
                measure?: string | null,
                scenario?: string | null,
                periodToken?: string | null,
                timeGrain?: string | null,
                dimensionOverrides?:  {
                  __typename: string,
                  datasetSource?: DatasetSource | null,
                  account_hierarchy?: string | null,
                  account?: string | null,
                  location_hierarchy?: string | null,
                  location?: string | null,
                  project_hierarchy?: string | null,
                  project?: string | null,
                  company_hierarchy?: string | null,
                  company?: string | null,
                  product_hierarchy?: string | null,
                  product?: string | null,
                  revgp_hierarchy?: string | null,
                  revgp?: string | null,
                  datasource_hierarchy?: string | null,
                  datasource?: string | null,
                  channel_hierarchy?: string | null,
                  channel?: string | null,
                  costcenter_hierarchy?: string | null,
                  costcenter?: string | null,
                  costtype?: string | null,
                  costpool?: string | null,
                  fieldtype?: string | null,
                } | null,
                format?:  {
                  __typename: string,
                  cellDefault?: CellFormat | null,
                } | null,
                calculation?:  {
                  __typename: string,
                  type?: ColumnCalculationType | null,
                  operands?: Array< string | null > | null,
                } | null,
                // --- derived per request, never stored ---
                colKey?: string | null,
                excelLetter?: string | null,
                resolvedScenario?: string | null,
                resolvedPeriod?: string | null,
              } | null > | null,
            } | null > | null,
          } | {
            __typename: "BlockNode",
            nodeId?: string | null,
            kind?: HeaderNodeKind | null,
            label?: string | null,
            footnotes?: Array< number | null > | null,
            // --- authored on the node, round-trips into HeaderBlockInput ---
            blockId?: number | null,
            measure?: string | null,
            scenario?: string | null,
            periodToken?: string | null,
            timeGrain?: string | null,
            nonMaterial?: boolean | null,
            dimensionOverrides?:  {
              __typename: string,
              datasetSource?: DatasetSource | null,
              account_hierarchy?: string | null,
              account?: string | null,
              location_hierarchy?: string | null,
              location?: string | null,
              project_hierarchy?: string | null,
              project?: string | null,
              company_hierarchy?: string | null,
              company?: string | null,
              product_hierarchy?: string | null,
              product?: string | null,
              revgp_hierarchy?: string | null,
              revgp?: string | null,
              datasource_hierarchy?: string | null,
              datasource?: string | null,
              channel_hierarchy?: string | null,
              channel?: string | null,
              costcenter_hierarchy?: string | null,
              costcenter?: string | null,
              costtype?: string | null,
              costpool?: string | null,
              fieldtype?: string | null,
            } | null,
            datasetSource?: DatasetSource | null,
            // --- derived per request, never stored ---
            resolvedScenario?: string | null,
            resolvedPeriod?: string | null,
            scenarioPlacement?: HeaderPlacement | null,
            periodPlacement?: HeaderPlacement | null,
            periodOwnedByLeaves?: boolean | null,
            bandPeriod?: string | null,
            children?:  Array< {
              __typename: string,
              nodeId?: string | null,
              kind?: HeaderNodeKind | null,
              label?: string | null,
              footnotes?: Array< number | null > | null,
              // --- authored on the node, round-trips into HeaderLeafInput ---
              columnNo?: number | null,
              measure?: string | null,
              scenario?: string | null,
              periodToken?: string | null,
              timeGrain?: string | null,
              dimensionOverrides?:  {
                __typename: string,
                datasetSource?: DatasetSource | null,
                account_hierarchy?: string | null,
                account?: string | null,
                location_hierarchy?: string | null,
                location?: string | null,
                project_hierarchy?: string | null,
                project?: string | null,
                company_hierarchy?: string | null,
                company?: string | null,
                product_hierarchy?: string | null,
                product?: string | null,
                revgp_hierarchy?: string | null,
                revgp?: string | null,
                datasource_hierarchy?: string | null,
                datasource?: string | null,
                channel_hierarchy?: string | null,
                channel?: string | null,
                costcenter_hierarchy?: string | null,
                costcenter?: string | null,
                costtype?: string | null,
                costpool?: string | null,
                fieldtype?: string | null,
              } | null,
              format?:  {
                __typename: string,
                cellDefault?: CellFormat | null,
              } | null,
              calculation?:  {
                __typename: string,
                type?: ColumnCalculationType | null,
                operands?: Array< string | null > | null,
              } | null,
              // --- derived per request, never stored ---
              colKey?: string | null,
              excelLetter?: string | null,
              resolvedScenario?: string | null,
              resolvedPeriod?: string | null,
            } | null > | null,
          }
        ) | null > | null,
      } | {
        __typename: "GroupNode",
        nodeId?: string | null,
        kind?: HeaderNodeKind | null,
        label?: string | null,
        footnotes?: Array< number | null > | null,
        children?:  Array< {
          __typename: string,
          nodeId?: string | null,
          kind?: HeaderNodeKind | null,
          label?: string | null,
          footnotes?: Array< number | null > | null,
          // --- authored on the node, round-trips into HeaderBlockInput ---
          blockId?: number | null,
          measure?: string | null,
          scenario?: string | null,
          periodToken?: string | null,
          timeGrain?: string | null,
          nonMaterial?: boolean | null,
          dimensionOverrides?:  {
            __typename: string,
            datasetSource?: DatasetSource | null,
            account_hierarchy?: string | null,
            account?: string | null,
            location_hierarchy?: string | null,
            location?: string | null,
            project_hierarchy?: string | null,
            project?: string | null,
            company_hierarchy?: string | null,
            company?: string | null,
            product_hierarchy?: string | null,
            product?: string | null,
            revgp_hierarchy?: string | null,
            revgp?: string | null,
            datasource_hierarchy?: string | null,
            datasource?: string | null,
            channel_hierarchy?: string | null,
            channel?: string | null,
            costcenter_hierarchy?: string | null,
            costcenter?: string | null,
            costtype?: string | null,
            costpool?: string | null,
            fieldtype?: string | null,
          } | null,
          datasetSource?: DatasetSource | null,
          // --- derived per request, never stored ---
          resolvedScenario?: string | null,
          resolvedPeriod?: string | null,
          scenarioPlacement?: HeaderPlacement | null,
          periodPlacement?: HeaderPlacement | null,
          periodOwnedByLeaves?: boolean | null,
          bandPeriod?: string | null,
          children?:  Array< {
            __typename: string,
            nodeId?: string | null,
            kind?: HeaderNodeKind | null,
            label?: string | null,
            footnotes?: Array< number | null > | null,
            // --- authored on the node, round-trips into HeaderLeafInput ---
            columnNo?: number | null,
            measure?: string | null,
            scenario?: string | null,
            periodToken?: string | null,
            timeGrain?: string | null,
            dimensionOverrides?:  {
              __typename: string,
              datasetSource?: DatasetSource | null,
              account_hierarchy?: string | null,
              account?: string | null,
              location_hierarchy?: string | null,
              location?: string | null,
              project_hierarchy?: string | null,
              project?: string | null,
              company_hierarchy?: string | null,
              company?: string | null,
              product_hierarchy?: string | null,
              product?: string | null,
              revgp_hierarchy?: string | null,
              revgp?: string | null,
              datasource_hierarchy?: string | null,
              datasource?: string | null,
              channel_hierarchy?: string | null,
              channel?: string | null,
              costcenter_hierarchy?: string | null,
              costcenter?: string | null,
              costtype?: string | null,
              costpool?: string | null,
              fieldtype?: string | null,
            } | null,
            format?:  {
              __typename: string,
              cellDefault?: CellFormat | null,
            } | null,
            calculation?:  {
              __typename: string,
              type?: ColumnCalculationType | null,
              operands?: Array< string | null > | null,
            } | null,
            // --- derived per request, never stored ---
            colKey?: string | null,
            excelLetter?: string | null,
            resolvedScenario?: string | null,
            resolvedPeriod?: string | null,
          } | null > | null,
        } | null > | null,
      } | {
        __typename: "BlockNode",
        nodeId?: string | null,
        kind?: HeaderNodeKind | null,
        label?: string | null,
        footnotes?: Array< number | null > | null,
        // --- authored on the node, round-trips into HeaderBlockInput ---
        blockId?: number | null,
        measure?: string | null,
        scenario?: string | null,
        periodToken?: string | null,
        timeGrain?: string | null,
        nonMaterial?: boolean | null,
        dimensionOverrides?:  {
          __typename: string,
          datasetSource?: DatasetSource | null,
          account_hierarchy?: string | null,
          account?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          company_hierarchy?: string | null,
          company?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          costpool?: string | null,
          fieldtype?: string | null,
        } | null,
        datasetSource?: DatasetSource | null,
        // --- derived per request, never stored ---
        resolvedScenario?: string | null,
        resolvedPeriod?: string | null,
        scenarioPlacement?: HeaderPlacement | null,
        periodPlacement?: HeaderPlacement | null,
        periodOwnedByLeaves?: boolean | null,
        bandPeriod?: string | null,
        children?:  Array< {
          __typename: string,
          nodeId?: string | null,
          kind?: HeaderNodeKind | null,
          label?: string | null,
          footnotes?: Array< number | null > | null,
          // --- authored on the node, round-trips into HeaderLeafInput ---
          columnNo?: number | null,
          measure?: string | null,
          scenario?: string | null,
          periodToken?: string | null,
          timeGrain?: string | null,
          dimensionOverrides?:  {
            __typename: string,
            datasetSource?: DatasetSource | null,
            account_hierarchy?: string | null,
            account?: string | null,
            location_hierarchy?: string | null,
            location?: string | null,
            project_hierarchy?: string | null,
            project?: string | null,
            company_hierarchy?: string | null,
            company?: string | null,
            product_hierarchy?: string | null,
            product?: string | null,
            revgp_hierarchy?: string | null,
            revgp?: string | null,
            datasource_hierarchy?: string | null,
            datasource?: string | null,
            channel_hierarchy?: string | null,
            channel?: string | null,
            costcenter_hierarchy?: string | null,
            costcenter?: string | null,
            costtype?: string | null,
            costpool?: string | null,
            fieldtype?: string | null,
          } | null,
          format?:  {
            __typename: string,
            cellDefault?: CellFormat | null,
          } | null,
          calculation?:  {
            __typename: string,
            type?: ColumnCalculationType | null,
            operands?: Array< string | null > | null,
          } | null,
          // --- derived per request, never stored ---
          colKey?: string | null,
          excelLetter?: string | null,
          resolvedScenario?: string | null,
          resolvedPeriod?: string | null,
        } | null > | null,
      }
    ) | null > | null,
    template_version?: string | null,
    created_by?: string | null,
    created_date?: string | null,
    last_updated_by?: string | null,
    last_updated_date?: string | null,
  } | null,
};

export type SaveCalcDefinitionMutationVariables = {
  userAlias?: string | null,
  request: SaveCalcDefinitionInput,
};

export type SaveCalcDefinitionMutation = {
  saveCalcDefinition?:  {
    __typename: "CalcDefinition",
    pk: string,
    sk: string,
    deck_id?: string | null,
    stem_kpi_id?: string | null,
    kpi_formula_template?: string | null,
    kpi_operands?:  Array< {
      __typename: "CalcOperand",
      ref?: string | null,
      kind?: CalcOperandKind | null,
      overrides: ( {
          __typename: "GalaxyKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          account_hierarchy?: string | null,
          account?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costpool?: string | null,
        } | {
          __typename: "HctrKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          measure_hierarchy?: string | null,
          measure?: string | null,
          transferDirection_hierarchy?: string | null,
          transferDirection?: string | null,
          workflow_hierarchy?: string | null,
          workflow?: string | null,
        }
      ) | null,
      deckline_id?: string | null,
      root_kpi_id?: string | null,
      kpi_variant_id?: string | null,
      kpi_id?: string | null,
    } | null > | null,
    dataset_source?: DatasetSource | null,
    last_updated_by?: string | null,
    last_updated_date?: string | null,
  } | null,
};

export type GetDeckQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
};

export type GetDeckQuery = {
  getDeck?:  {
    __typename: "Deck",
    pk: string,
    sk: string,
    deckGSI_pk?: string | null,
    deckGSI_sk?: string | null,
    deck_name?: string | null,
    created_date?: string | null,
    last_updated_date?: string | null,
    created_by?: string | null,
    last_updated_by?: string | null,
    current_user?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    publish_status?: PublishStatus | null,
    publish_user?: string | null,
    publish_deck_cycle?: string | null,
    has_active_system_run?: boolean | null,
    last_publish_date?: string | null,
    publish_timestamp?: string | null,
    deck_cycle?: string | null,
    enabled_page_grains?: Array< string | null > | null,
    enabled_datasets?: Array< DatasetSource | null > | null,
  } | null,
};

export type GetLockedPagesForDeckQueryVariables = {
  deck_id: string,
  userAlias?: string | null,
};

export type GetLockedPagesForDeckQuery = {
  getLockedPagesForDeck?:  Array< {
    __typename: "LockEvent",
    deck_id: string,
    page_name?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    lock_scope: LockScope,
  } | null > | null,
};

export type GetAllDecksQueryVariables = {
  userAlias?: string | null,
};

export type GetAllDecksQuery = {
  getAllDecks?:  Array< {
    __typename: "Deck",
    pk: string,
    sk: string,
    deckGSI_pk?: string | null,
    deckGSI_sk?: string | null,
    deck_name?: string | null,
    created_date?: string | null,
    last_updated_date?: string | null,
    created_by?: string | null,
    last_updated_by?: string | null,
    current_user?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    publish_status?: PublishStatus | null,
    publish_user?: string | null,
    publish_deck_cycle?: string | null,
    has_active_system_run?: boolean | null,
    last_publish_date?: string | null,
    publish_timestamp?: string | null,
    deck_cycle?: string | null,
    enabled_page_grains?: Array< string | null > | null,
    enabled_datasets?: Array< DatasetSource | null > | null,
  } | null > | null,
};

export type GetTOCEntryQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
  toc_id: string,
};

export type GetTOCEntryQuery = {
  getTOCEntry?:  Array< {
    __typename: "TOCEntry",
    pk: string,
    sk: string,
    toc_id: string,
    page_id?: string | null,
    page_no?: string | null,
    toc_page_name?: string | null,
    page_name?: string | null,
    is_visible?: boolean | null,
    is_active?: boolean | null,
    group_name?: string | null,
    serial_no?: number | null,
    created_date?: string | null,
    last_updated_date?: string | null,
    schedule_type?: ScheduleType | null,
  } | null > | null,
};

export type GetAllTOCEntriesForaDeckQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
};

export type GetAllTOCEntriesForaDeckQuery = {
  getAllTOCEntriesForaDeck?:  Array< {
    __typename: "TOCEntry",
    pk: string,
    sk: string,
    toc_id: string,
    page_id?: string | null,
    page_no?: string | null,
    toc_page_name?: string | null,
    page_name?: string | null,
    is_visible?: boolean | null,
    is_active?: boolean | null,
    group_name?: string | null,
    serial_no?: number | null,
    created_date?: string | null,
    last_updated_date?: string | null,
    schedule_type?: ScheduleType | null,
  } | null > | null,
};

export type GetTOCEntriesForaDeckByPageStatusQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
  is_active: boolean,
};

export type GetTOCEntriesForaDeckByPageStatusQuery = {
  getTOCEntriesForaDeckByPageStatus?:  Array< {
    __typename: "TOCEntry",
    pk: string,
    sk: string,
    toc_id: string,
    page_id?: string | null,
    page_no?: string | null,
    toc_page_name?: string | null,
    page_name?: string | null,
    is_visible?: boolean | null,
    is_active?: boolean | null,
    group_name?: string | null,
    serial_no?: number | null,
    created_date?: string | null,
    last_updated_date?: string | null,
    schedule_type?: ScheduleType | null,
  } | null > | null,
};

export type GetActiveTOCEntriesByScheduleTypeQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
  is_active: boolean,
  schedule_type: ScheduleType,
};

export type GetActiveTOCEntriesByScheduleTypeQuery = {
  getActiveTOCEntriesByScheduleType?:  Array< {
    __typename: "TOCEntry",
    pk: string,
    sk: string,
    toc_id: string,
    page_id?: string | null,
    page_no?: string | null,
    toc_page_name?: string | null,
    page_name?: string | null,
    is_visible?: boolean | null,
    is_active?: boolean | null,
    group_name?: string | null,
    serial_no?: number | null,
    created_date?: string | null,
    last_updated_date?: string | null,
    schedule_type?: ScheduleType | null,
  } | null > | null,
};

export type GetAllScenarioManagementEntriesForaDeckQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
};

export type GetAllScenarioManagementEntriesForaDeckQuery = {
  getAllScenarioManagementEntriesForaDeck?:  Array< {
    __typename: "ScenarioManagementEntry",
    pk: string,
    sk: string,
    scenario_id: string,
    deck_cycle?: string | null,
    month?: string | null,
    page_name?: string | null,
    page_no?: string | null,
    sno?: string | null,
    is_external_page?: boolean | null,
    page_grain?: string | null,
    schedule_type: ScheduleType,
    last_updated_date?: string | null,
    is_supplemental?: boolean | null,
    is_blankpage?: boolean | null,
    toc_sno?: string | null,
    toc_page_no?: string | null,
  } | null > | null,
};

export type GetScenarioManagementEntriesByScheduleTypeQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
  schedule_type: ScheduleType,
};

export type GetScenarioManagementEntriesByScheduleTypeQuery = {
  getScenarioManagementEntriesByScheduleType?:  Array< {
    __typename: "ScenarioManagementEntry",
    pk: string,
    sk: string,
    scenario_id: string,
    deck_cycle?: string | null,
    month?: string | null,
    page_name?: string | null,
    page_no?: string | null,
    sno?: string | null,
    is_external_page?: boolean | null,
    page_grain?: string | null,
    schedule_type: ScheduleType,
    last_updated_date?: string | null,
    is_supplemental?: boolean | null,
    is_blankpage?: boolean | null,
    toc_sno?: string | null,
    toc_page_no?: string | null,
  } | null > | null,
};

export type GetPageQueryVariables = {
  userAlias?: string | null,
  page_id: string,
};

export type GetPageQuery = {
  getPage?:  {
    __typename: "Page",
    pk: string,
    sk: string,
    pageGSI_pk?: string | null,
    pageGSI_sk?: string | null,
    page_name?: string | null,
    deck_id?: string | null,
    page_grain?: string | null,
    page_no?: number | null,
    page_drivers:  Array<( {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        account_hierarchy?: string | null,
        account?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costpool?: string | null,
      } | {
        __typename: "HctrKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        measure_hierarchy?: string | null,
        measure?: string | null,
        transferDirection_hierarchy?: string | null,
        transferDirection?: string | null,
        workflow_hierarchy?: string | null,
        workflow?: string | null,
      }
    ) | null > | null,
    previous_page_id?: string | null,
    next_page_id?: string | null,
    page_type?: string | null,
    denominator_label?: DenominatorLabelValues | null,
    scale?: PageScaleValues | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    layout_family?: string | null,
    report_header?: string | null,
  } | null,
};

export type GetDecklinesQueryVariables = {
  userAlias?: string | null,
  page_id: string,
};

export type GetDecklinesQuery = {
  getDecklines?:  Array< {
    __typename: "Deckline",
    calc_members?:  {
      __typename: "CalcExpression",
      dimension?: string | null,
      tokens?:  Array< {
        __typename: "CalcToken",
        kind?: CalcTokenKind | null,
        value?: string | null,
      } | null > | null,
      pins?:  Array< {
        __typename: "CalcPin",
        dimension?: string | null,
        node?: string | null,
      } | null > | null,
    } | null,
    pk: string,
    sk: string,
    page_name?: string | null,
    kpi_id?: string | null,
    kpi_id_by_override?:  Array< {
      __typename: "DecklineCellKpiId",
      override_set?:  {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
        fieldtype?: string | null,
      } | null,
      kpi_id: string,
    } | null > | null,
    kpi_name?: string | null,
    kpi_formula?: string | null,
    serial_no?: string | null,
    is_code_or_description?: CodeOrDescription | null,
    is_format_bold?: boolean | null,
    is_format_italics?: boolean | null,
    is_format_underline?: boolean | null,
    format_text_color?: string | null,
    format_cell_color?: string | null,
    format_cell_default?: CellFormat | null,
    format_cell_overrides?:  Array< {
      __typename: "DecklineCellFormat",
      colKey: string,
      format: CellFormat,
    } | null > | null,
    blankline_type?: BlanklineType | null,
    is_format_borderline?: boolean | null,
    footnotes?: Array< number | null > | null,
    subtotal_formula?: string | null,
    subtotal_parent?: string | null,
    is_calculated_kpi?: CalculatedKPIValues | null,
    kpi_type?: KPIType | null,
    deckline_kind?: DecklineKind | null,
    deckline_drivers: ( {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        account_hierarchy?: string | null,
        account?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costpool?: string | null,
      } | {
        __typename: "HctrKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        measure_hierarchy?: string | null,
        measure?: string | null,
        transferDirection_hierarchy?: string | null,
        transferDirection?: string | null,
        workflow_hierarchy?: string | null,
        workflow?: string | null,
      }
    ) | null,
    is_exception?: boolean | null,
    page_section?: string | null,
    column_template?: string | null,
    adjcalcflag?: boolean | null,
    exceptioncalculatedkpiflag?: boolean | null,
    bordertopflag?: boolean | null,
    borderrightflag?: boolean | null,
    borderbottomflag?: boolean | null,
    borderleftflag?: boolean | null,
    borderweightflag?: BorderWeight | null,
    textunderlineflag?: boolean | null,
    denominator_kpi_id_for_pct?: string | null,
    denominator_kpi_id_drivers?:  {
      __typename: "GalaxyKPIDrivers",
      datasetSource?: DatasetSource | null,
      account_hierarchy?: string | null,
      account?: string | null,
      location_hierarchy?: string | null,
      location?: string | null,
      project_hierarchy?: string | null,
      project?: string | null,
      company_hierarchy?: string | null,
      company?: string | null,
      product_hierarchy?: string | null,
      product?: string | null,
      revgp_hierarchy?: string | null,
      revgp?: string | null,
      datasource_hierarchy?: string | null,
      datasource?: string | null,
      channel_hierarchy?: string | null,
      channel?: string | null,
      costcenter_hierarchy?: string | null,
      costcenter?: string | null,
      costtype?: string | null,
      costpool?: string | null,
      fieldtype?: string | null,
    } | null,
    denominator_is_calculated_kpi?: CalculatedKPIValues | null,
    denominator_kpi_formula?: string | null,
    root_kpi_id?: string | null,
    kpi_variant_id?: string | null,
    display_name?: string | null,
    denominator_kpi_variant_id?: string | null,
    measure?: string | null,
    kpi_name_indent_level?: number | null,
    fxinclflag?: string | null,
    calcdivisionflag?: string | null,
    bps_override_flag?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      commentId: string,
      user: string,
      commentDesc: string,
      timestamp: string,
    } | null > | null,
  } | null > | null,
};

export type GetDeckColumnsQueryVariables = {
  userAlias?: string | null,
  page_id: string,
};

export type GetDeckColumnsQuery = {
  getDeckColumns?:  Array< {
    __typename: "DeckColumn",
    pk: string,
    sk: string,
    deckColumnGSI_pk?: string | null,
    deckColumnGSI_sk?: string | null,
    deck_id?: string | null,
    column_template?: string | null,
    page_section?: string | null,
    column_no?: number | null,
    column_title?: string | null,
    column_name?: string | null,
    no_of_columns?: number | null,
    column_description?: string | null,
    scenario_display_name?: string | null,
    scenario_period?: string | null,
    block_id?: number | null,
    comparison_scenario?: string | null,
    comparison_scenario_period?: string | null,
    fx_scenario?: string | null,
    fx_scenario_period?: string | null,
    denominator_scenario?: string | null,
    denominator_scenario_period?: string | null,
    block_header?: string | null,
    non_material_flag?: string | null,
    denominator_kpi_exception_flag?: string | null,
    last_updated_date?: string | null,
    column_mapping_group?: string | null,
    report_header?: string | null,
    time_grain?: string | null,
    deck_cycle?: string | null,
  } | null > | null,
};

export type GetKPIQueryVariables = {
  userAlias?: string | null,
  kpi_id: string,
};

export type GetKPIQuery = {
  getKPI?:  {
    __typename: "KPI",
    pk: string,
    sk: string,
    is_calculated_kpi?: CalculatedKPIValues | null,
    kpi_type?: KPIType | null,
    kpi_formula?: string | null,
    kpi_map: ( {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        account_hierarchy?: string | null,
        account?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costpool?: string | null,
      } | {
        __typename: "HctrKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        measure_hierarchy?: string | null,
        measure?: string | null,
        transferDirection_hierarchy?: string | null,
        transferDirection?: string | null,
        workflow_hierarchy?: string | null,
        workflow?: string | null,
      }
    ) | null,
    last_updated_date?: string | null,
  } | null,
};

export type GetFootnoteForPageQueryVariables = {
  userAlias?: string | null,
  page_id: string,
  footnote_id?: string | null,
};

export type GetFootnoteForPageQuery = {
  getFootnoteForPage?:  Array< {
    __typename: "Footnote",
    pk: string,
    sk: string,
    footnote_no?: string | null,
    footnote_description?: string | null,
  } | null > | null,
};

export type GetAuditHistoryForPageQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
  page_id: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetAuditHistoryForPageQuery = {
  getAuditHistoryForPage?:  {
    __typename: "AuditHistoryPaginatedResponse",
    items?:  Array< {
      __typename: "AuditHistory",
      pk: string,
      sk: string,
      change_type?: string | null,
      before?: string | null,
      after?: string | null,
      user?: string | null,
      dateTime?: string | null,
      row?: string | null,
      page_name?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetAuditHistoryForDeckQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
};

export type GetAuditHistoryForDeckQuery = {
  getAuditHistoryForDeck?:  Array< {
    __typename: "AuditHistory",
    pk: string,
    sk: string,
    change_type?: string | null,
    before?: string | null,
    after?: string | null,
    user?: string | null,
    dateTime?: string | null,
    row?: string | null,
    page_name?: string | null,
  } | null > | null,
};

export type GetDeckColumnForDeckQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
  publish_timestamp?: string | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetDeckColumnForDeckQuery = {
  getDeckColumnForDeck?:  {
    __typename: "DeckColumnPaginatedResponse",
    items?:  Array< {
      __typename: "DeckColumn",
      pk: string,
      sk: string,
      deckColumnGSI_pk?: string | null,
      deckColumnGSI_sk?: string | null,
      deck_id?: string | null,
      column_template?: string | null,
      page_section?: string | null,
      column_no?: number | null,
      column_title?: string | null,
      column_name?: string | null,
      no_of_columns?: number | null,
      column_description?: string | null,
      scenario_display_name?: string | null,
      scenario_period?: string | null,
      block_id?: number | null,
      comparison_scenario?: string | null,
      comparison_scenario_period?: string | null,
      fx_scenario?: string | null,
      fx_scenario_period?: string | null,
      denominator_scenario?: string | null,
      denominator_scenario_period?: string | null,
      block_header?: string | null,
      non_material_flag?: string | null,
      denominator_kpi_exception_flag?: string | null,
      last_updated_date?: string | null,
      column_mapping_group?: string | null,
      report_header?: string | null,
      time_grain?: string | null,
      deck_cycle?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetAllKPIsQueryVariables = {
  userAlias?: string | null,
  deck_id?: string | null,
  publish_timestamp?: string | null,
  kpi_type?: KPIType | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetAllKPIsQuery = {
  getAllKPIs?:  {
    __typename: "KPIPaginatedResponse",
    items?:  Array< {
      __typename: "KPI",
      pk: string,
      sk: string,
      is_calculated_kpi?: CalculatedKPIValues | null,
      kpi_type?: KPIType | null,
      kpi_formula?: string | null,
      kpi_map: ( {
          __typename: "GalaxyKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          account_hierarchy?: string | null,
          account?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costpool?: string | null,
        } | {
          __typename: "HctrKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          measure_hierarchy?: string | null,
          measure?: string | null,
          transferDirection_hierarchy?: string | null,
          transferDirection?: string | null,
          workflow_hierarchy?: string | null,
          workflow?: string | null,
        }
      ) | null,
      last_updated_date?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetKPIUpdatesForDeckQueryVariables = {
  userAlias: string,
  deck_id: string,
  publish_timestamp: string,
  kpi_type?: KPIType | null,
  nextToken?: string | null,
};

export type GetKPIUpdatesForDeckQuery = {
  getKPIUpdatesForDeck?:  {
    __typename: "KPIPaginatedResponse",
    items?:  Array< {
      __typename: "KPI",
      pk: string,
      sk: string,
      is_calculated_kpi?: CalculatedKPIValues | null,
      kpi_type?: KPIType | null,
      kpi_formula?: string | null,
      kpi_map: ( {
          __typename: "GalaxyKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          account_hierarchy?: string | null,
          account?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costpool?: string | null,
        } | {
          __typename: "HctrKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          measure_hierarchy?: string | null,
          measure?: string | null,
          transferDirection_hierarchy?: string | null,
          transferDirection?: string | null,
          workflow_hierarchy?: string | null,
          workflow?: string | null,
        }
      ) | null,
      last_updated_date?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetPagesByPageNameQueryVariables = {
  userAlias?: string | null,
  page_name: string,
  page_grain?: string | null,
  deck_id?: string | null,
};

export type GetPagesByPageNameQuery = {
  getPagesByPageName?:  Array< {
    __typename: "Page",
    pk: string,
    sk: string,
    pageGSI_pk?: string | null,
    pageGSI_sk?: string | null,
    page_name?: string | null,
    deck_id?: string | null,
    page_grain?: string | null,
    page_no?: number | null,
    page_drivers:  Array<( {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        account_hierarchy?: string | null,
        account?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costpool?: string | null,
      } | {
        __typename: "HctrKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        measure_hierarchy?: string | null,
        measure?: string | null,
        transferDirection_hierarchy?: string | null,
        transferDirection?: string | null,
        workflow_hierarchy?: string | null,
        workflow?: string | null,
      }
    ) | null > | null,
    previous_page_id?: string | null,
    next_page_id?: string | null,
    page_type?: string | null,
    denominator_label?: DenominatorLabelValues | null,
    scale?: PageScaleValues | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    layout_family?: string | null,
    report_header?: string | null,
  } | null > | null,
};

export type GetPagesByDeckQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
};

export type GetPagesByDeckQuery = {
  getPagesByDeck?:  Array< {
    __typename: "Page",
    pk: string,
    sk: string,
    pageGSI_pk?: string | null,
    pageGSI_sk?: string | null,
    page_name?: string | null,
    deck_id?: string | null,
    page_grain?: string | null,
    page_no?: number | null,
    page_drivers:  Array<( {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        account_hierarchy?: string | null,
        account?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costpool?: string | null,
      } | {
        __typename: "HctrKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        measure_hierarchy?: string | null,
        measure?: string | null,
        transferDirection_hierarchy?: string | null,
        transferDirection?: string | null,
        workflow_hierarchy?: string | null,
        workflow?: string | null,
      }
    ) | null > | null,
    previous_page_id?: string | null,
    next_page_id?: string | null,
    page_type?: string | null,
    denominator_label?: DenominatorLabelValues | null,
    scale?: PageScaleValues | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    layout_family?: string | null,
    report_header?: string | null,
  } | null > | null,
};

export type GetRootKPIsQueryVariables = {
  userAlias?: string | null,
  root_kpi_id?: string | null,
  nextToken?: string | null,
};

export type GetRootKPIsQuery = {
  getRootKPIs?:  {
    __typename: "RootKPIPaginatedResponse",
    items?:  Array< {
      __typename: "RootKPI",
      pk: string,
      sk: string,
      root_kpi_id: string,
      root_kpi_name: string,
      kpi_type: KPIType,
      variants?:  Array< {
        __typename: "KPIVariant",
        pk: string,
        sk: string,
        kpi_variant_id: string,
        variant_name: string,
        variant_overrides: ( {
            __typename: "GalaxyKPIDrivers",
            datasetSource?: DatasetSource | null,
            company_hierarchy?: string | null,
            company?: string | null,
            costcenter_hierarchy?: string | null,
            costcenter?: string | null,
            costtype?: string | null,
            fieldtype?: string | null,
            location_hierarchy?: string | null,
            location?: string | null,
            account_hierarchy?: string | null,
            account?: string | null,
            project_hierarchy?: string | null,
            project?: string | null,
            product_hierarchy?: string | null,
            product?: string | null,
            revgp_hierarchy?: string | null,
            revgp?: string | null,
            datasource_hierarchy?: string | null,
            datasource?: string | null,
            channel_hierarchy?: string | null,
            channel?: string | null,
            costpool?: string | null,
          } | {
            __typename: "HctrKPIDrivers",
            datasetSource?: DatasetSource | null,
            company_hierarchy?: string | null,
            company?: string | null,
            costcenter_hierarchy?: string | null,
            costcenter?: string | null,
            costtype?: string | null,
            fieldtype?: string | null,
            location_hierarchy?: string | null,
            location?: string | null,
            measure_hierarchy?: string | null,
            measure?: string | null,
            transferDirection_hierarchy?: string | null,
            transferDirection?: string | null,
            workflow_hierarchy?: string | null,
            workflow?: string | null,
          }
        ) | null,
        dataset_source?: DatasetSource | null,
        kpi_type: KPIType,
        root_kpi_id: string,
        created_date?: string | null,
        last_updated_date?: string | null,
        created_by?: string | null,
        last_updated_by?: string | null,
      } | null > | null,
      created_date?: string | null,
      created_by?: string | null,
      last_updated_date?: string | null,
      last_updated_by?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetVariantsForRootKPIQueryVariables = {
  userAlias?: string | null,
  root_kpi_id: string,
};

export type GetVariantsForRootKPIQuery = {
  getVariantsForRootKPI?:  Array< {
    __typename: "KPIVariant",
    pk: string,
    sk: string,
    kpi_variant_id: string,
    variant_name: string,
    variant_overrides: ( {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        account_hierarchy?: string | null,
        account?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costpool?: string | null,
      } | {
        __typename: "HctrKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        measure_hierarchy?: string | null,
        measure?: string | null,
        transferDirection_hierarchy?: string | null,
        transferDirection?: string | null,
        workflow_hierarchy?: string | null,
        workflow?: string | null,
      }
    ) | null,
    dataset_source?: DatasetSource | null,
    kpi_type: KPIType,
    root_kpi_id: string,
    created_date?: string | null,
    last_updated_date?: string | null,
    created_by?: string | null,
    last_updated_by?: string | null,
  } | null > | null,
};

export type GetKPIVariantQueryVariables = {
  userAlias?: string | null,
  root_kpi_id: string,
  kpi_variant_id: string,
};

export type GetKPIVariantQuery = {
  getKPIVariant?:  {
    __typename: "KPIVariant",
    pk: string,
    sk: string,
    kpi_variant_id: string,
    variant_name: string,
    variant_overrides: ( {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        account_hierarchy?: string | null,
        account?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costpool?: string | null,
      } | {
        __typename: "HctrKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        measure_hierarchy?: string | null,
        measure?: string | null,
        transferDirection_hierarchy?: string | null,
        transferDirection?: string | null,
        workflow_hierarchy?: string | null,
        workflow?: string | null,
      }
    ) | null,
    dataset_source?: DatasetSource | null,
    kpi_type: KPIType,
    root_kpi_id: string,
    created_date?: string | null,
    last_updated_date?: string | null,
    created_by?: string | null,
    last_updated_by?: string | null,
  } | null,
};

export type GetRootKPIUsageSummaryQueryVariables = {
  userAlias?: string | null,
  root_kpi_id: string,
};

export type GetRootKPIUsageSummaryQuery = {
  getRootKPIUsageSummary?:  {
    __typename: "KPIUsageSummary",
    root_kpi_id: string,
    root_kpi_name: string,
    total_deckline_count: number,
    total_page_count: number,
    total_core_page_count: number,
    total_deck_count: number,
    deck_usage:  Array< {
      __typename: "DeckUsageDetail",
      deck_id: string,
      deck_name: string,
      page_usage:  Array< {
        __typename: "CorePageUsageDetail",
        core_page_name: string,
        pages:  Array< {
          __typename: "PageUsageDetail",
          page_id: string,
          page_name: string,
          deckline_count: number,
          kpi_variant_ids: Array< string | null >,
        } | null >,
      } | null >,
    } | null >,
  } | null,
};

export type GetVariantUsageSummaryQueryVariables = {
  userAlias?: string | null,
  kpi_variant_id: string,
};

export type GetVariantUsageSummaryQuery = {
  getVariantUsageSummary?:  {
    __typename: "KPIUsageSummary",
    root_kpi_id: string,
    root_kpi_name: string,
    total_deckline_count: number,
    total_page_count: number,
    total_core_page_count: number,
    total_deck_count: number,
    deck_usage:  Array< {
      __typename: "DeckUsageDetail",
      deck_id: string,
      deck_name: string,
      page_usage:  Array< {
        __typename: "CorePageUsageDetail",
        core_page_name: string,
        pages:  Array< {
          __typename: "PageUsageDetail",
          page_id: string,
          page_name: string,
          deckline_count: number,
          kpi_variant_ids: Array< string | null >,
        } | null >,
      } | null >,
    } | null >,
  } | null,
};

export type GetKPIHierarchyAuditHistoryQueryVariables = {
  userAlias?: string | null,
  entities?: Array< KPIHierarchyAuditEntityInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetKPIHierarchyAuditHistoryQuery = {
  getKPIHierarchyAuditHistory?:  {
    __typename: "AuditHistoryPaginatedResponse",
    items?:  Array< {
      __typename: "AuditHistory",
      pk: string,
      sk: string,
      change_type?: string | null,
      before?: string | null,
      after?: string | null,
      user?: string | null,
      dateTime?: string | null,
      row?: string | null,
      page_name?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetPageLayoutQueryVariables = {
  userAlias?: string | null,
  page_id: string,
  resolve_periods?: boolean | null,
  rowMeasures?: Array< string | null > | null,
  deck_cycle?: string | null,
  publish_year?: string | null,
  as_of_date?: string | null,
};

export type GetPageLayoutQuery = {
  getPageLayout?:  {
    __typename: "PageLayout",
    pageId: string,
    sections?:  Array< {
      __typename: "PageLayoutSection",
      sectionId?: string | null,
      label?: string | null,
      columnHeaderTree:  Array<( {
          __typename: "GroupNode",
          nodeId?: string | null,
          kind?: HeaderNodeKind | null,
          label?: string | null,
          footnotes?: Array< number | null > | null,
          children?:  Array< {
            __typename: string,
            nodeId?: string | null,
            kind?: HeaderNodeKind | null,
            label?: string | null,
            footnotes?: Array< number | null > | null,
            // --- authored on the node, round-trips into HeaderBlockInput ---
            blockId?: number | null,
            measure?: string | null,
            scenario?: string | null,
            periodToken?: string | null,
            timeGrain?: string | null,
            nonMaterial?: boolean | null,
            dimensionOverrides?:  {
              __typename: string,
              datasetSource?: DatasetSource | null,
              account_hierarchy?: string | null,
              account?: string | null,
              location_hierarchy?: string | null,
              location?: string | null,
              project_hierarchy?: string | null,
              project?: string | null,
              company_hierarchy?: string | null,
              company?: string | null,
              product_hierarchy?: string | null,
              product?: string | null,
              revgp_hierarchy?: string | null,
              revgp?: string | null,
              datasource_hierarchy?: string | null,
              datasource?: string | null,
              channel_hierarchy?: string | null,
              channel?: string | null,
              costcenter_hierarchy?: string | null,
              costcenter?: string | null,
              costtype?: string | null,
              costpool?: string | null,
              fieldtype?: string | null,
            } | null,
            datasetSource?: DatasetSource | null,
            // --- derived per request, never stored ---
            resolvedScenario?: string | null,
            resolvedPeriod?: string | null,
            scenarioPlacement?: HeaderPlacement | null,
            periodPlacement?: HeaderPlacement | null,
            periodOwnedByLeaves?: boolean | null,
            bandPeriod?: string | null,
            children?:  Array< {
              __typename: string,
              nodeId?: string | null,
              kind?: HeaderNodeKind | null,
              label?: string | null,
              footnotes?: Array< number | null > | null,
              // --- authored on the node, round-trips into HeaderLeafInput ---
              columnNo?: number | null,
              measure?: string | null,
              scenario?: string | null,
              periodToken?: string | null,
              timeGrain?: string | null,
              dimensionOverrides?:  {
                __typename: string,
                datasetSource?: DatasetSource | null,
                account_hierarchy?: string | null,
                account?: string | null,
                location_hierarchy?: string | null,
                location?: string | null,
                project_hierarchy?: string | null,
                project?: string | null,
                company_hierarchy?: string | null,
                company?: string | null,
                product_hierarchy?: string | null,
                product?: string | null,
                revgp_hierarchy?: string | null,
                revgp?: string | null,
                datasource_hierarchy?: string | null,
                datasource?: string | null,
                channel_hierarchy?: string | null,
                channel?: string | null,
                costcenter_hierarchy?: string | null,
                costcenter?: string | null,
                costtype?: string | null,
                costpool?: string | null,
                fieldtype?: string | null,
              } | null,
              format?:  {
                __typename: string,
                cellDefault?: CellFormat | null,
              } | null,
              calculation?:  {
                __typename: string,
                type?: ColumnCalculationType | null,
                operands?: Array< string | null > | null,
              } | null,
              // --- derived per request, never stored ---
              colKey?: string | null,
              excelLetter?: string | null,
              resolvedScenario?: string | null,
              resolvedPeriod?: string | null,
            } | null > | null,
          } | null > | null,
        } | {
          __typename: "BlockNode",
          nodeId?: string | null,
          kind?: HeaderNodeKind | null,
          label?: string | null,
          footnotes?: Array< number | null > | null,
          // --- authored on the node, round-trips into HeaderBlockInput ---
          blockId?: number | null,
          measure?: string | null,
          scenario?: string | null,
          periodToken?: string | null,
          timeGrain?: string | null,
          nonMaterial?: boolean | null,
          dimensionOverrides?:  {
            __typename: string,
            datasetSource?: DatasetSource | null,
            account_hierarchy?: string | null,
            account?: string | null,
            location_hierarchy?: string | null,
            location?: string | null,
            project_hierarchy?: string | null,
            project?: string | null,
            company_hierarchy?: string | null,
            company?: string | null,
            product_hierarchy?: string | null,
            product?: string | null,
            revgp_hierarchy?: string | null,
            revgp?: string | null,
            datasource_hierarchy?: string | null,
            datasource?: string | null,
            channel_hierarchy?: string | null,
            channel?: string | null,
            costcenter_hierarchy?: string | null,
            costcenter?: string | null,
            costtype?: string | null,
            costpool?: string | null,
            fieldtype?: string | null,
          } | null,
          datasetSource?: DatasetSource | null,
          // --- derived per request, never stored ---
          resolvedScenario?: string | null,
          resolvedPeriod?: string | null,
          scenarioPlacement?: HeaderPlacement | null,
          periodPlacement?: HeaderPlacement | null,
          periodOwnedByLeaves?: boolean | null,
          bandPeriod?: string | null,
          children?:  Array< {
            __typename: string,
            nodeId?: string | null,
            kind?: HeaderNodeKind | null,
            label?: string | null,
            footnotes?: Array< number | null > | null,
            // --- authored on the node, round-trips into HeaderLeafInput ---
            columnNo?: number | null,
            measure?: string | null,
            scenario?: string | null,
            periodToken?: string | null,
            timeGrain?: string | null,
            dimensionOverrides?:  {
              __typename: string,
              datasetSource?: DatasetSource | null,
              account_hierarchy?: string | null,
              account?: string | null,
              location_hierarchy?: string | null,
              location?: string | null,
              project_hierarchy?: string | null,
              project?: string | null,
              company_hierarchy?: string | null,
              company?: string | null,
              product_hierarchy?: string | null,
              product?: string | null,
              revgp_hierarchy?: string | null,
              revgp?: string | null,
              datasource_hierarchy?: string | null,
              datasource?: string | null,
              channel_hierarchy?: string | null,
              channel?: string | null,
              costcenter_hierarchy?: string | null,
              costcenter?: string | null,
              costtype?: string | null,
              costpool?: string | null,
              fieldtype?: string | null,
            } | null,
            format?:  {
              __typename: string,
              cellDefault?: CellFormat | null,
            } | null,
            calculation?:  {
              __typename: string,
              type?: ColumnCalculationType | null,
              operands?: Array< string | null > | null,
            } | null,
            // --- derived per request, never stored ---
            colKey?: string | null,
            excelLetter?: string | null,
            resolvedScenario?: string | null,
            resolvedPeriod?: string | null,
          } | null > | null,
        }
      ) | null > | null,
      columns?:  Array< {
        __typename: "ColumnLeaf",
        colKey: string,
        excelLetter?: string | null,
        blockId?: number | null,
        columnNo?: number | null,
        label?: string | null,
        measure?: string | null,
        blockLabel?: string | null,
        blockFootnotes?: Array< number | null > | null,
        groupId?: number | null,
        groupLabel?: string | null,
        groupFootnotes?: Array< number | null > | null,
        scenarioDisplay?: string | null,
        scenarioPeriod?: string | null,
        timeGrain?: string | null,
        nonMaterial?: boolean | null,
        operator?: ColumnOperator | null,
        operands?:  Array< {
          __typename: "ColumnOperand",
          role?: OperandRole | null,
          scenarioToken?: string | null,
          scenario?: string | null,
          periodToken?: string | null,
          period?: string | null,
          yearOffset?: number | null,
          monthOffset?: number | null,
        } | null > | null,
        measureOverlays?:  Array< {
          __typename: "ColumnMeasureOverlay",
          measure: string,
          operator?: ColumnOperator | null,
          operands?:  Array< {
            __typename: "ColumnOperand",
            role?: OperandRole | null,
            scenarioToken?: string | null,
            scenario?: string | null,
            periodToken?: string | null,
            period?: string | null,
            yearOffset?: number | null,
            monthOffset?: number | null,
          } | null > | null,
          terms?:  Array< {
            __typename: "ColumnMeasureTerm",
            role: OperandRole,
            operator?: ColumnOperator | null,
            operands?:  Array< {
              __typename: "ColumnOperand",
              role?: OperandRole | null,
              scenarioToken?: string | null,
              scenario?: string | null,
              periodToken?: string | null,
              period?: string | null,
              yearOffset?: number | null,
              monthOffset?: number | null,
            } | null > | null,
          } | null > | null,
        } | null > | null,
        format?:  {
          __typename: "LeafFormat",
          cellDefault?: CellFormat | null,
        } | null,
        calculation?:  {
          __typename: "ColumnCalculation",
          type?: ColumnCalculationType | null,
          operands?: Array< string | null > | null,
        } | null,
        footnotes?: Array< number | null > | null,
        datasetSource?: DatasetSource | null,
        dimensionOverrides?:  {
          __typename: "GalaxyKPIDrivers",
          datasetSource?: DatasetSource | null,
          account_hierarchy?: string | null,
          account?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          company_hierarchy?: string | null,
          company?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          costpool?: string | null,
          fieldtype?: string | null,
        } | null,
      } | null > | null,
    } | null > | null,
    footnotes?: Array< number | null > | null,
    layoutVersion?: string | null,
    templateVersion?: string | null,
    resolvedDeckCycle?: string | null,
    resolvedTemplateCycle?: string | null,
  } | null,
};

export type GetColumnTemplateCatalogQueryVariables = {
  userAlias?: string | null,
  deck_id: string,
  layout_family?: string | null,
  deck_cycle?: string | null,
  grain?: string | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetColumnTemplateCatalogQuery = {
  getColumnTemplateCatalog?:  {
    __typename: "LayoutTemplateCatalogPage",
    items?:  Array< {
      __typename: "LayoutTemplateSummary",
      pk?: string | null,
      sk?: string | null,
      layout_family?: string | null,
      deck_cycle?: string | null,
      grain?: string | null,
      name?: string | null,
      template_version?: string | null,
      last_updated_by?: string | null,
      last_updated_date?: string | null,
      node_counts?:  {
        __typename: "NodeCounts",
        groups?: number | null,
        blocks?: number | null,
        leaves?: number | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type OnLockDeckSubscriptionVariables = {
};

export type OnLockDeckSubscription = {
  onLockDeck?:  {
    __typename: "LockEvent",
    deck_id: string,
    page_name?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    lock_scope: LockScope,
  } | null,
};

export type OnReleaseDeckLockSubscriptionVariables = {
};

export type OnReleaseDeckLockSubscription = {
  onReleaseDeckLock?:  {
    __typename: "LockEvent",
    deck_id: string,
    page_name?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    lock_scope: LockScope,
  } | null,
};

export type OnLockPageSubscriptionVariables = {
};

export type OnLockPageSubscription = {
  onLockPage?:  {
    __typename: "LockEvent",
    deck_id: string,
    page_name?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    lock_scope: LockScope,
  } | null,
};

export type OnReleasePageLockSubscriptionVariables = {
};

export type OnReleasePageLockSubscription = {
  onReleasePageLock?:  {
    __typename: "LockEvent",
    deck_id: string,
    page_name?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    lock_scope: LockScope,
  } | null,
};

export type OnUpdateDeckSubscriptionVariables = {
  publish_status?: PublishStatus | null,
};

export type OnUpdateDeckSubscription = {
  onUpdateDeck?:  {
    __typename: "Deck",
    pk: string,
    sk: string,
    deckGSI_pk?: string | null,
    deckGSI_sk?: string | null,
    deck_name?: string | null,
    created_date?: string | null,
    last_updated_date?: string | null,
    created_by?: string | null,
    last_updated_by?: string | null,
    current_user?: string | null,
    locked_by?: string | null,
    locked_at?: string | null,
    lock_expiry?: string | null,
    publish_status?: PublishStatus | null,
    publish_user?: string | null,
    publish_deck_cycle?: string | null,
    has_active_system_run?: boolean | null,
    last_publish_date?: string | null,
    publish_timestamp?: string | null,
    deck_cycle?: string | null,
    enabled_page_grains?: Array< string | null > | null,
    enabled_datasets?: Array< DatasetSource | null > | null,
  } | null,
};

export type OnUpdateKPIVariantSubscriptionVariables = {
  page_ids?: Array< string | null > | null,
};

export type OnUpdateKPIVariantSubscription = {
  onUpdateKPIVariant?:  {
    __typename: "UpdateKPIVariantResponse",
    pk: string,
    sk: string,
    kpi_variant_id: string,
    variant_name: string,
    variant_overrides: ( {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        account_hierarchy?: string | null,
        account?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costpool?: string | null,
      } | {
        __typename: "HctrKPIDrivers",
        datasetSource?: DatasetSource | null,
        company_hierarchy?: string | null,
        company?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        fieldtype?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        measure_hierarchy?: string | null,
        measure?: string | null,
        transferDirection_hierarchy?: string | null,
        transferDirection?: string | null,
        workflow_hierarchy?: string | null,
        workflow?: string | null,
      }
    ) | null,
    dataset_source?: DatasetSource | null,
    kpi_type: KPIType,
    root_kpi_id: string,
    created_date?: string | null,
    last_updated_date?: string | null,
    created_by?: string | null,
    last_updated_by?: string | null,
    affected_page_ids?: Array< string | null > | null,
    updated_decklines?:  Array< {
      __typename: "Deckline",
      calc_members?:  {
        __typename: "CalcExpression",
        dimension?: string | null,
        tokens?:  Array< {
          __typename: "CalcToken",
          kind?: CalcTokenKind | null,
          value?: string | null,
        } | null > | null,
        pins?:  Array< {
          __typename: "CalcPin",
          dimension?: string | null,
          node?: string | null,
        } | null > | null,
      } | null,
      pk: string,
      sk: string,
      page_name?: string | null,
      kpi_id?: string | null,
      kpi_id_by_override?:  Array< {
        __typename: "DecklineCellKpiId",
        override_set?:  {
          __typename: "GalaxyKPIDrivers",
          datasetSource?: DatasetSource | null,
          account_hierarchy?: string | null,
          account?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          company_hierarchy?: string | null,
          company?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          costpool?: string | null,
          fieldtype?: string | null,
        } | null,
        kpi_id: string,
      } | null > | null,
      kpi_name?: string | null,
      kpi_formula?: string | null,
      serial_no?: string | null,
      is_code_or_description?: CodeOrDescription | null,
      is_format_bold?: boolean | null,
      is_format_italics?: boolean | null,
      is_format_underline?: boolean | null,
      format_text_color?: string | null,
      format_cell_color?: string | null,
      format_cell_default?: CellFormat | null,
      format_cell_overrides?:  Array< {
        __typename: "DecklineCellFormat",
        colKey: string,
        format: CellFormat,
      } | null > | null,
      blankline_type?: BlanklineType | null,
      is_format_borderline?: boolean | null,
      footnotes?: Array< number | null > | null,
      subtotal_formula?: string | null,
      subtotal_parent?: string | null,
      is_calculated_kpi?: CalculatedKPIValues | null,
      kpi_type?: KPIType | null,
      deckline_kind?: DecklineKind | null,
      deckline_drivers: ( {
          __typename: "GalaxyKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          account_hierarchy?: string | null,
          account?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costpool?: string | null,
        } | {
          __typename: "HctrKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          measure_hierarchy?: string | null,
          measure?: string | null,
          transferDirection_hierarchy?: string | null,
          transferDirection?: string | null,
          workflow_hierarchy?: string | null,
          workflow?: string | null,
        }
      ) | null,
      is_exception?: boolean | null,
      page_section?: string | null,
      column_template?: string | null,
      adjcalcflag?: boolean | null,
      exceptioncalculatedkpiflag?: boolean | null,
      bordertopflag?: boolean | null,
      borderrightflag?: boolean | null,
      borderbottomflag?: boolean | null,
      borderleftflag?: boolean | null,
      borderweightflag?: BorderWeight | null,
      textunderlineflag?: boolean | null,
      denominator_kpi_id_for_pct?: string | null,
      denominator_kpi_id_drivers?:  {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
        fieldtype?: string | null,
      } | null,
      denominator_is_calculated_kpi?: CalculatedKPIValues | null,
      denominator_kpi_formula?: string | null,
      root_kpi_id?: string | null,
      kpi_variant_id?: string | null,
      display_name?: string | null,
      denominator_kpi_variant_id?: string | null,
      measure?: string | null,
      kpi_name_indent_level?: number | null,
      fxinclflag?: string | null,
      calcdivisionflag?: string | null,
      bps_override_flag?: string | null,
      comments?:  Array< {
        __typename: "Comment",
        commentId: string,
        user: string,
        commentDesc: string,
        timestamp: string,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type OnDeleteKPIVariantSubscriptionVariables = {
  page_ids?: Array< string | null > | null,
};

export type OnDeleteKPIVariantSubscription = {
  onDeleteKPIVariant?:  {
    __typename: "DeleteKPIVariantResponse",
    kpi_variant_id: string,
    root_kpi_id: string,
    root_kpi_auto_deleted: boolean,
    affected_page_ids?: Array< string | null > | null,
    deleted_decklines?:  Array< {
      __typename: "Deckline",
      calc_members?:  {
        __typename: "CalcExpression",
        dimension?: string | null,
        tokens?:  Array< {
          __typename: "CalcToken",
          kind?: CalcTokenKind | null,
          value?: string | null,
        } | null > | null,
        pins?:  Array< {
          __typename: "CalcPin",
          dimension?: string | null,
          node?: string | null,
        } | null > | null,
      } | null,
      pk: string,
      sk: string,
      page_name?: string | null,
      kpi_id?: string | null,
      kpi_id_by_override?:  Array< {
        __typename: "DecklineCellKpiId",
        override_set?:  {
          __typename: "GalaxyKPIDrivers",
          datasetSource?: DatasetSource | null,
          account_hierarchy?: string | null,
          account?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          company_hierarchy?: string | null,
          company?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          costpool?: string | null,
          fieldtype?: string | null,
        } | null,
        kpi_id: string,
      } | null > | null,
      kpi_name?: string | null,
      kpi_formula?: string | null,
      serial_no?: string | null,
      is_code_or_description?: CodeOrDescription | null,
      is_format_bold?: boolean | null,
      is_format_italics?: boolean | null,
      is_format_underline?: boolean | null,
      format_text_color?: string | null,
      format_cell_color?: string | null,
      format_cell_default?: CellFormat | null,
      format_cell_overrides?:  Array< {
        __typename: "DecklineCellFormat",
        colKey: string,
        format: CellFormat,
      } | null > | null,
      blankline_type?: BlanklineType | null,
      is_format_borderline?: boolean | null,
      footnotes?: Array< number | null > | null,
      subtotal_formula?: string | null,
      subtotal_parent?: string | null,
      is_calculated_kpi?: CalculatedKPIValues | null,
      kpi_type?: KPIType | null,
      deckline_kind?: DecklineKind | null,
      deckline_drivers: ( {
          __typename: "GalaxyKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          account_hierarchy?: string | null,
          account?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costpool?: string | null,
        } | {
          __typename: "HctrKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          measure_hierarchy?: string | null,
          measure?: string | null,
          transferDirection_hierarchy?: string | null,
          transferDirection?: string | null,
          workflow_hierarchy?: string | null,
          workflow?: string | null,
        }
      ) | null,
      is_exception?: boolean | null,
      page_section?: string | null,
      column_template?: string | null,
      adjcalcflag?: boolean | null,
      exceptioncalculatedkpiflag?: boolean | null,
      bordertopflag?: boolean | null,
      borderrightflag?: boolean | null,
      borderbottomflag?: boolean | null,
      borderleftflag?: boolean | null,
      borderweightflag?: BorderWeight | null,
      textunderlineflag?: boolean | null,
      denominator_kpi_id_for_pct?: string | null,
      denominator_kpi_id_drivers?:  {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
        fieldtype?: string | null,
      } | null,
      denominator_is_calculated_kpi?: CalculatedKPIValues | null,
      denominator_kpi_formula?: string | null,
      root_kpi_id?: string | null,
      kpi_variant_id?: string | null,
      display_name?: string | null,
      denominator_kpi_variant_id?: string | null,
      measure?: string | null,
      kpi_name_indent_level?: number | null,
      fxinclflag?: string | null,
      calcdivisionflag?: string | null,
      bps_override_flag?: string | null,
      comments?:  Array< {
        __typename: "Comment",
        commentId: string,
        user: string,
        commentDesc: string,
        timestamp: string,
      } | null > | null,
    } | null > | null,
    reordered_decklines?:  Array< {
      __typename: "Deckline",
      calc_members?:  {
        __typename: "CalcExpression",
        dimension?: string | null,
        tokens?:  Array< {
          __typename: "CalcToken",
          kind?: CalcTokenKind | null,
          value?: string | null,
        } | null > | null,
        pins?:  Array< {
          __typename: "CalcPin",
          dimension?: string | null,
          node?: string | null,
        } | null > | null,
      } | null,
      pk: string,
      sk: string,
      page_name?: string | null,
      kpi_id?: string | null,
      kpi_id_by_override?:  Array< {
        __typename: "DecklineCellKpiId",
        override_set?:  {
          __typename: "GalaxyKPIDrivers",
          datasetSource?: DatasetSource | null,
          account_hierarchy?: string | null,
          account?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          company_hierarchy?: string | null,
          company?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          costpool?: string | null,
          fieldtype?: string | null,
        } | null,
        kpi_id: string,
      } | null > | null,
      kpi_name?: string | null,
      kpi_formula?: string | null,
      serial_no?: string | null,
      is_code_or_description?: CodeOrDescription | null,
      is_format_bold?: boolean | null,
      is_format_italics?: boolean | null,
      is_format_underline?: boolean | null,
      format_text_color?: string | null,
      format_cell_color?: string | null,
      format_cell_default?: CellFormat | null,
      format_cell_overrides?:  Array< {
        __typename: "DecklineCellFormat",
        colKey: string,
        format: CellFormat,
      } | null > | null,
      blankline_type?: BlanklineType | null,
      is_format_borderline?: boolean | null,
      footnotes?: Array< number | null > | null,
      subtotal_formula?: string | null,
      subtotal_parent?: string | null,
      is_calculated_kpi?: CalculatedKPIValues | null,
      kpi_type?: KPIType | null,
      deckline_kind?: DecklineKind | null,
      deckline_drivers: ( {
          __typename: "GalaxyKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          account_hierarchy?: string | null,
          account?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costpool?: string | null,
        } | {
          __typename: "HctrKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          measure_hierarchy?: string | null,
          measure?: string | null,
          transferDirection_hierarchy?: string | null,
          transferDirection?: string | null,
          workflow_hierarchy?: string | null,
          workflow?: string | null,
        }
      ) | null,
      is_exception?: boolean | null,
      page_section?: string | null,
      column_template?: string | null,
      adjcalcflag?: boolean | null,
      exceptioncalculatedkpiflag?: boolean | null,
      bordertopflag?: boolean | null,
      borderrightflag?: boolean | null,
      borderbottomflag?: boolean | null,
      borderleftflag?: boolean | null,
      borderweightflag?: BorderWeight | null,
      textunderlineflag?: boolean | null,
      denominator_kpi_id_for_pct?: string | null,
      denominator_kpi_id_drivers?:  {
        __typename: "GalaxyKPIDrivers",
        datasetSource?: DatasetSource | null,
        account_hierarchy?: string | null,
        account?: string | null,
        location_hierarchy?: string | null,
        location?: string | null,
        project_hierarchy?: string | null,
        project?: string | null,
        company_hierarchy?: string | null,
        company?: string | null,
        product_hierarchy?: string | null,
        product?: string | null,
        revgp_hierarchy?: string | null,
        revgp?: string | null,
        datasource_hierarchy?: string | null,
        datasource?: string | null,
        channel_hierarchy?: string | null,
        channel?: string | null,
        costcenter_hierarchy?: string | null,
        costcenter?: string | null,
        costtype?: string | null,
        costpool?: string | null,
        fieldtype?: string | null,
      } | null,
      denominator_is_calculated_kpi?: CalculatedKPIValues | null,
      denominator_kpi_formula?: string | null,
      root_kpi_id?: string | null,
      kpi_variant_id?: string | null,
      display_name?: string | null,
      denominator_kpi_variant_id?: string | null,
      measure?: string | null,
      kpi_name_indent_level?: number | null,
      fxinclflag?: string | null,
      calcdivisionflag?: string | null,
      bps_override_flag?: string | null,
      comments?:  Array< {
        __typename: "Comment",
        commentId: string,
        user: string,
        commentDesc: string,
        timestamp: string,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type OnUpdateRootKPISubscriptionVariables = {
};

export type OnUpdateRootKPISubscription = {
  onUpdateRootKPI?:  {
    __typename: "RootKPI",
    pk: string,
    sk: string,
    root_kpi_id: string,
    root_kpi_name: string,
    kpi_type: KPIType,
    variants?:  Array< {
      __typename: "KPIVariant",
      pk: string,
      sk: string,
      kpi_variant_id: string,
      variant_name: string,
      variant_overrides: ( {
          __typename: "GalaxyKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          account_hierarchy?: string | null,
          account?: string | null,
          project_hierarchy?: string | null,
          project?: string | null,
          product_hierarchy?: string | null,
          product?: string | null,
          revgp_hierarchy?: string | null,
          revgp?: string | null,
          datasource_hierarchy?: string | null,
          datasource?: string | null,
          channel_hierarchy?: string | null,
          channel?: string | null,
          costpool?: string | null,
        } | {
          __typename: "HctrKPIDrivers",
          datasetSource?: DatasetSource | null,
          company_hierarchy?: string | null,
          company?: string | null,
          costcenter_hierarchy?: string | null,
          costcenter?: string | null,
          costtype?: string | null,
          fieldtype?: string | null,
          location_hierarchy?: string | null,
          location?: string | null,
          measure_hierarchy?: string | null,
          measure?: string | null,
          transferDirection_hierarchy?: string | null,
          transferDirection?: string | null,
          workflow_hierarchy?: string | null,
          workflow?: string | null,
        }
      ) | null,
      dataset_source?: DatasetSource | null,
      kpi_type: KPIType,
      root_kpi_id: string,
      created_date?: string | null,
      last_updated_date?: string | null,
      created_by?: string | null,
      last_updated_by?: string | null,
    } | null > | null,
    created_date?: string | null,
    created_by?: string | null,
    last_updated_date?: string | null,
    last_updated_by?: string | null,
  } | null,
};
